// Mirrors server/models.py — the FastAPI server's response shapes.

// Generated straight from the live FastAPI OpenAPI schema — see
// ao_control_plane_read_models_and_request_path_2026_09_04.md [UI] P0 (audit X2).
// `npm run generate:openapi-client` regenerates it; `npm run check:openapi-client`
// (wired into scripts/quality-gates.sh as ao-dashboard-openapi-client) fails the
// gate if it's stale relative to the live schema.
import type { components } from "./generated/api-types";

export type Mode = "mock" | "live";

export interface ModeInfo {
  mode: Mode;
  is_mock: boolean;
  admin_enabled: boolean;
  db_path: string;
  // Backend's resolved worktree base — machine-specific (VM vs laptop). Used to
  // default a worker's worktree to `<workspace_root>/.tabs/<slot>/` for the
  // backend the dashboard is actually pointed at.
  workspace_root: string;
}

export type SlotStatus =
  "working" | "blocked" | "stale" | "idle" | "paused" | "killed" | "offline" | "pending_delete" | "ambiguous";
// "offline" (fleet_wide_dispatch_stall_35_idle_1888_queued_2026_09_04.md, 2026-09-06): a
// node-hosted slot the fleet has given up on entirely — distinct from "stale" (still
// reclaimable) and "killed" (host present, will respawn). Landed in
// server/models/_types.py 2026-09-06 but missing from this hand-maintained alias until
// now (found 2026-09-17 while adding "ambiguous" below).
// "pending_delete" (ao_operator_actions_ionos_node_slot_parity_2026_09_09): a node-hosted
// slot whose Delete was requested but not yet confirmed by the node — see the identical
// SlotStatus addition + its full rationale in server/models/_types.py.
// "ambiguous" (ao_liveness_unified_design_and_contradiction_closeout_2026_09_16.md
// Section E, 2026-09-17): reserved for the future liveness oracle's AMBIGUOUS verdict —
// see server/models/_types.py for the full rationale. Not yet SET by any code path.
export type TaskStatus = "queued" | "dispatched" | "done" | "cancelled" | "skipped" | "blocked";
export type ContextPressure = "low" | "medium" | "high" | "thrashing";
export type FromRole = "main" | "review" | "operator";

export type StageSource = "declared" | "inferred" | "ref";
export type DeclaredStepStatus = "pending" | "active" | "done" | "failed" | "skipped";

export interface SlotStageStep {
  n: number;
  type: string;
  summary?: string | null;
  status: DeclaredStepStatus;
}

/** Compact stage read model on each slot in /api/state (plan ao_node_worker_parity_click_through_program_2026_09_26,
 * [BACKEND] "Read model for declared stages"). `current_step` is the step number `n`; `index`/`total` are
 * 1-based position/length; `since` is when the slot entered `step_type`; `source: "ref"` means `step_type` is a
 * ref-derived `gate_green|gate_red|landed|promoted`; `undeclared` = task >10 min old with no declared plan.
 * `steps` is optional: when absent the stepper renders index/total placeholders. */
export interface SlotStage {
  current_step: number | null;
  index: number | null;
  total: number | null;
  step_type: string | null;
  since: string | null;
  source: StageSource | null;
  undeclared: boolean;
  steps?: SlotStageStep[] | null;
}

export interface SlotView {
  slot_id: number;
  /** Declared/inferred/ref-derived stage (see SlotStage). Optional for fail-safe: an older backend omits it, and the
   * card then renders no map at all rather than a fabricated one. */
  stage?: SlotStage | null;
  /** D11 logical host name (ao_ionos_remote_slots_build_2026_08_31 Phase 2). `slot_id`
   * COLLIDES across hosts by design (central can run slots 21-33 while a node
   * independently runs its own 21-30) — a composite `(host, slot_id)` identity is
   * REQUIRED for any React key or Map lookup over a fleet-wide slot list; see
   * `slotKey`/`groupSlotsByHost` in layout.tsx. `null` only for a response built before
   * this field existed — never true for a live-queried row. Optional for the same
   * fail-safe reason as `kind`/`reserved_for` below: an older backend omits it. */
  host?: string | null;
  status: SlotStatus;
  current_task: string | null;
  /** Parent plan of the task currently dispatched to this slot (joined from
   * TaskRow.plan_ref via dispatched_to == slot_id). null when no live dispatch. */
  plan_ref: string | null;
  /** The typed one-off role occupying this slot when it has no backlog task —
   * "cicd" / "conflict_resolver" / "data_pipeline_failure" / "plan_health" /
   * "plan_reconciler" / etc. null or the "worker" sentinel means this is an
   * ordinary backlog-dispatched slot (read current_task/plan_ref instead).
   * Optional for fail-safe: an older backend omits it. */
  spawn_base_role?: string | null;
  assigned_at: string | null;
  /** When this slot's tmux session was actually spawned — distinct from
   * assigned_at (dispatch time): the gap between the two is pre-boot/auth lag.
   * Optional for fail-safe: an older backend omits it. */
  last_spawned_at?: string | null;
  last_ping: string | null;
  /** Distinct from `last_ping` (2026-09-27 operator complaint: a fresh `last_ping`
   * doesn't mean the worker did anything — a bare /heartbeat or /boot poll refreshes
   * it too). Timestamp of the slot's most recent GENUINE task-scoped signal
   * (slot_progress/slot_done/slot_done_verified/slot_done_rejected_dirty/slot_blocked).
   * Null when never logged (fresh slot, or a node-hosted row — see the backend
   * SlotView docstring for that disclosed gap), never a fabricated value. Optional
   * for fail-safe: an older backend omits it. */
  last_real_activity_at?: string | null;
  /** The WORKER's own last heartbeat, as the NODE observed it — distinct from `last_ping` on a
   * NODE-hosted row (PC8, ao_node_worker_parity_followups_2026_10_13). `SlotRow.last_ping` is
   * deliberately bumped to the node's own tick whenever the node reports `session_state="busy"`
   * (kill-safety: it stops `node_stale_requeue` requeueing a worker sitting in one long tool call),
   * so a wedged node-hosted worker's row reads a permanently fresh `last_ping` — measured 10:58Z,
   * all 5 working rows served `last_ping` 10:57:48.6Z while the observation's own
   * `last_worker_heartbeat_at` was 2 h 19 m old. This is that honest signal, carried separately.
   * Null for a CENTRAL row (whose `last_ping` already IS the worker's own heartbeat — a central
   * worker's /progress reaches central directly) and for a node whose observation never carried
   * one, never a fabricated value. Optional for fail-safe: an older backend omits it. */
  worker_last_heartbeat_at?: string | null;
  last_msg: string | null;
  worktree: string | null;
  branch: string | null;
  operator: string | null;
  model: string | null;
  /** `claude --effort` level: low / medium / high / xhigh / max. */
  effort: string | null;
  /** Free-form thinking-budget label, e.g. "max", "32k", "off". */
  thinking: string | null;
  context_used_pct: number;
  /** Live token count behind `context_used_pct`. Null when the reading came from the
   * pane fallback rather than the transcript probe. */
  context_tokens?: number | null;
  /** Window `context_used_pct` was divided by. Surfaced so a wrong window — the
   * actual cause of every context incident so far — is catchable by eye. */
  context_window_tokens?: number | null;
  context_pressure: ContextPressure;
  compactions_total: number;
  compactions_last_hour: number;
  last_compacted_at: string | null;
  account_id: string | null;
  /** "anthropic" | "deepseek" — resolved server-side from accounts.json against
   * account_id. null when account_id itself is null, or the bound account_id is
   * no longer in accounts.json (deepseek_claude_blended_provider_routing_2026_07_28
   * [UI] P1). */
  provider: string | null;
  /** "pro" | "flash" for a deepseek-provider slot, null otherwise (deepseek_flash_ab_
   * routing_test_2026_08_05 [UI] follow-up). The Fleet table's `model` field
   * ("sonnet" etc.) is the Claude Code harness's own tier alias, not meaningful for
   * a DeepSeek-routed slot — the dashboard shows this instead when provider is set. */
  deepseek_variant: string | null;
  /** tmux session name when worker was spawned via dashboard's "Spawn here"
   * button; null for manually-pasted workers. Operator attaches via
   * `tmux attach -t <name>` (typically over SSH from mobile). */
  tmux_session: string | null;
  /** Independent alive signals (C2, 2026-05-19): worker_alive is "recent
   * /heartbeat seen", tmux_alive is "tmux session for this slot currently
   * exists". worker_alive && !tmux_alive means the worker process is fine
   * but its terminal died — `tmux attach` won't work; surface that to
   * the operator instead of pretending the slot is dead. */
  worker_alive: boolean;
  tmux_alive: boolean;
  /** True when context_used_pct / context_pressure are a FROZEN snapshot (no recent
   * heartbeat) rather than current — render them as last-known, never as fact.
   * Live 2026-08-06: prod slot 3 asserted `100% / thrashing` while sending no
   * heartbeats at all. Only set when pct > 0, so idle 0% slots are not flagged. */
  context_reading_stale: boolean;
  /** Backend-computed lifecycle phase (ao_worker_lifecycle 2026-07-10 Phase D).
   * Usually mirrors `status`, but a freshly-spawned live session reads
   * "pre_boot" (no post-spawn heartbeat yet) or "booting" (STEP-0
   * boot-started ping seen, /boot not completed). Optional for fail-safe:
   * older backends omit it and the badge falls back to `status`. */
  phase?: string | null;
  /** Per-slot git-status snapshot (latest cron report from this slot's host). */
  git_status: SlotGitStatus | null;
  /** Slot role: "main" (slot 0) and "review" agents run the singleton main /
   * review agents shown in the Agents panel — the dashboard filters them OUT of
   * the worker Fleet list. "worker" is a normal task-worker slot. Optional for
   * fail-safe: a slot with no `kind` (legacy / partial response) is treated as a
   * worker and stays visible. (2026-06-27 fleet-vs-agents split.) */
  kind?: "main" | "review" | "worker";
  /** Structural capacity reservation (2026-08-15): computed server-side each request
   * from the LIVE slot roster (config.ci_escalation_reserved_slot_ids() /
   * scheduled_task_reserved_slot_ids()), never a stored field — so this shifts
   * automatically as the fleet grows/shrinks, no manual relabeling needed. Distinct
   * from `kind`: a "worker" slot can additionally be "ci_escalation" or
   * "scheduled_task" reserved. Optional/undefined on an older backend response —
   * treat as unknown, not "backlog". */
  reserved_for?: "main" | "review" | "ci_escalation" | "scheduled_task" | "backlog";
  /** Fleet status-badge hover reasons (ao_fleet_slot_state_reason_tooltips 2026-08-27) —
   * why this slot is in its current status. Each is only populated for the matching
   * `status`/`phase`; undefined/null elsewhere. `idle_reason`: a structural reserve or an
   * active declared wait explains an idle slot (a backlog-pool idle slot with no declared
   * wait has neither, so this stays null — the dispatch-filter-blocked case isn't classified
   * yet). `preboot_elapsed_seconds`: seconds since spawn, only while `phase` is "pre_boot"/
   * "booting" — pair with `current_task` for "about to work on X" when a task was pre-bound
   * at spawn. `stale_*`: read back from the stale sweep's own activity_log event. `last_*`:
   * read back from this slot's most recent kill's activity_log event. */
  idle_reason?: string | null;
  preboot_elapsed_seconds?: number | null;
  stale_silence_seconds?: number | null;
  stale_threshold_seconds?: number | null;
  stale_reason?: string | null;
  last_kill_reason?: string | null;
  last_death_class?: string | null;
  /** Per-slot token usage (deepseek_usage.py generalized, 2026-08-05 follow-up:
   * "tokens per task and by orchestrator" ruling) — provider-agnostic, populated
   * for any slot with a live session (kind="main"/"review" included). session_* =
   * whole current session; current_task_* = only usage since assigned_at (resets
   * per dispatch). Optional/null: older backends omit it, or no poller tick yet. */
  session_input_tokens?: number | null;
  session_output_tokens?: number | null;
  /** Per-SESSION turn count (ao_v2_fleet_visibility_and_reconciliation_2026_09_03
   * Phase 5 BACKEND P2). No current_task-scoped counterpart exists anywhere in the
   * system — central's own live-slot state tracks no turn count at all, so this is
   * populated ONLY for a node-hosted slot, forwarded verbatim from the node's own
   * WorkerSlotObservation.session_turn_count. null = no node tick yet (node row) or
   * no such live signal exists at all (central row) — never a fabricated 0. */
  session_turn_count?: number | null;
  /** Per-slot resource telemetry (ao_fleet_slot_resource_ui_and_scale_controls_2026_09_05.md
   * todo 1) — forwarded verbatim from a node-hosted slot's own WorkerSlotObservation. null
   * means NOT MEASURED THIS TICK, never a fabricated zero (same honesty contract as the
   * backend's own WorkerSlotObservation docstring) — a central-hosted slot has no per-slot
   * sampler at all today, so these stay null unconditionally for a central row; a disclosed
   * gap, not an oversight. `cpu_pct` is deliberately UNBOUNDED above 100 — a multi-process/
   * multi-threaded slot can legitimately use more than one core. */
  cpu_pct?: number | null;
  rss_bytes?: number | null;
  io_read_bytes?: number | null;
  io_write_bytes?: number | null;
  disk_bytes?: number | null;
  resource_sample_at?: string | null;
  /** True when `resource_sample_at` is set but older than the backend's own freshness
   * window (same 180s convention as `worker_alive`) — computed server-side to avoid
   * client/backend clock skew. False whenever `resource_sample_at` is null ("never
   * measured" and "measured, but stale" are two distinct states). */
  resource_reading_stale?: boolean;
  current_task_input_tokens?: number | null;
  current_task_output_tokens?: number | null;
  /** Cache-token split (ao_fleet_cache_tokens_and_task_count_2026_08_05) — same
   * session-vs-current-task convention as above; null = no tick yet. */
  session_cache_creation_input_tokens?: number | null;
  session_cache_read_input_tokens?: number | null;
  current_task_cache_creation_input_tokens?: number | null;
  current_task_cache_read_input_tokens?: number | null;
  /** Live $ spend (ao_fleet_live_spend_badge_2026_08_05) — same session-vs-
   * current-task convention as above; null = no tick yet, OR the priced scope
   * includes an unpriced turn (never a misleading partial sum). */
  session_spend_usd?: number | null;
  current_task_spend_usd?: number | null;
  /** DeepSeek native-proxy reasoning-token breakdown (deepseek_native_usage_
   * reasoning_tokens_visibility_2026_08_12) — same session-vs-current-task
   * convention as above, but joined by claude_session_id against
   * DeepSeekNativeUsageRow rather than read off the transcript-parse path the
   * fields above use (DeepSeek's Anthropic-compat endpoint silently drops it).
   * NOT additive spend — a subset WITHIN output_tokens. null = no matching
   * native-usage row (non-DeepSeek session, or one that predates the native
   * proxy), never a 0. */
  session_reasoning_tokens?: number | null;
  current_task_reasoning_tokens?: number | null;
  /** How many tasks THIS slot has completed, lifetime — a tmux session is a fixed
   * per-slot name reused across every sequential task until a full worker respawn,
   * so this is how the Fleet table distinguishes a freshly-spun-up slot from one
   * that has already run many tasks. */
  tasks_completed?: number;
  /** Slot-routing affinity ("none"/"low"/"medium"/"high") of the CURRENT task —
   * same field/meaning as BacklogTaskView.affinity, joined here so the Fleet
   * table can show it without a second round-trip to /api/backlog. null when
   * the slot has no current_task. */
  current_task_affinity?: SlotAffinity | null;
  /** Declared-wait deadline (SSOT server/declared_wait.py, 2026-08-23): a worker sets
   * this before a known-long silent call (a foreground `quality-gates.sh` pass, a
   * blocking VM launch) and every backend liveness judge treats the slot as alive
   * until it passes. Was previously visible only by decoding the free-text
   * `last_msg` ("declared wait <n>s: <command snippet>"); typed here so the
   * dashboard can render a distinct indicator instead. null when no wait is
   * currently declared (never declared, or already resolved/expired — see
   * `is_within_declared_wait` for "still active"). Optional for fail-safe: an
   * older backend omits it. */
  busy_until?: string | null;
  /** Convenience flag, computed server-side (`declared_wait.within_declared_wait`) so
   * the dashboard never re-derives "is now still before the deadline" against its own
   * (possibly-skewed) clock. True only while `busy_until` is set AND in the future.
   * Optional/defaults to false on an older backend. */
  is_within_declared_wait?: boolean;
  /** Context-plateau marker (SlotRow.context_plateau_since, SSOT
   * server/context_lifecycle.py's plateau detector + `_mark_slot_plateau`,
   * 2026-09-30). A slot whose context% stopped climbing over the plateau window is
   * very likely wedged (stuck/looping) rather than working — previously the
   * detector recorded this ONLY as a `context_plateau_detected` activity row, so
   * the slot kept rendering as an ordinary `working` row and the wedge was
   * invisible to an operator watching the Fleet UI (plan
   * ao_fleet_stabilisation_host_db_pt2, todo "Surface wedged slots in the
   * dashboard"). This is the streak's own start time, so the badge can say how long
   * it has been wedged. null when no plateau is in force; optional for fail-safe
   * against an older backend. Distinct from `busy_until` above — that is a HEALTHY
   * worker declaring a long silent call, this is the failure it was being confused
   * with. */
  context_plateau_since?: string | null;
  /** The roughly-flat context% the slot is stuck at (null while not plateaued, and
   * never a fabricated 0). */
  context_plateau_pct?: number | null;
  /** Convenience flag, computed ONCE server-side against status + tmux_session
   * (`routes/state.py`'s `_is_context_plateaued`, the same read-time-filter shape as
   * the declared-wait liveness gate) so the dashboard never re-derives "is this
   * marker still live" itself. True only while a marker exists AND the slot is still
   * a live working session. Optional/defaults to false on an older backend. */
  is_context_plateaued?: boolean;
}

export type RepoGitState =
  "clean" | "dirty" | "ahead" | "behind" | "diverged" | "detached" | "fetch-fail" | "no-merge-base" | "no-remote-ref";

export interface RepoStatus {
  name: string;
  branch: string;
  state: RepoGitState;
  dirty_files: number;
  ahead: number;
  behind: number;
  local_sha: string;
  integration_branch: string;
  /** Oldest mtime among the dirty working-tree files. Drives the dirty red flash. */
  dirty_oldest_mtime: string | null;
  /** Server-set timestamp: when this repo first entered (and stayed in) a non-clean state.
   * Cleared when state returns to clean+up-to-date. Legacy — superseded by the two
   * ground-truth commit-graph fields below for ahead/diverged/behind red-thresholding. */
  not_clean_since: string | null;
  /** Commit timestamp of the OLDEST commit in `git log <remote>..HEAD` — ground truth
   * for ahead/diverged staleness, recomputed fresh every reporter tick. Null when
   * ahead is 0 or the reporter predates this field. */
  ahead_oldest_commit_ts: string | null;
  /** Commit timestamp of the OLDEST commit in `git log HEAD..<remote>` — ground truth
   * for behind staleness, recomputed fresh every reporter tick. Null when behind is 0
   * or the reporter predates this field. */
  behind_oldest_commit_ts: string | null;
}

export interface SlotGitStatus {
  slot_id: number;
  reported_at: string;
  host: string | null;
  repos: RepoStatus[];
}

// --- Fleet git-health (fleet_git_health_orchestrator_2026_06_10.md) ----------

export interface RepoGitHealth {
  name: string;
  state: RepoGitState;
  dirty_files: number;
  /**
   * Up to 5 raw `git status --porcelain` lines (status code + path) for this repo's
   * dirty files when dirty_files > 0; empty/absent when clean. Already produced by the
   * reporter (`unified-trading-ci/scripts/dev/slot-git-status-report.sh`, which derives
   * dirty_files from this same sample's length, so the two can never diverge) and
   * already present in `src/generated/api-types.ts` — it was simply never surfaced
   * here. Lets the dashboard answer "which files", not just "how many": part 3 of the
   * original ask (ao_midtask_handoff_and_coordination_gaps_umbrella_2026_09_19.md).
   * Optional: an older reporter that omits it posts the same shape it always did.
   */
  dirty_files_sample?: string[];
  ahead: number;
  behind: number;
  local_sha: string;
  not_clean_since: string | null;
  dirty_oldest_mtime: string | null;
  ahead_oldest_commit_ts: string | null;
  behind_oldest_commit_ts: string | null;
  unpushed_plans: string[];
  /** Path-B invariant: slot HEAD must be ancestor-or-equal of LDR. True for ahead/diverged. */
  drift_violation: boolean;
}

export interface SlotGitHealth {
  slot_id: number;
  host: string | null;
  reported_at: string | null;
  /** reported_at older than 10 min → the reporter cron is dead/absent. */
  reporter_stale: boolean;
  ff_pull_last_run: string | null;
  ff_pull_last_result: string | null;
  /** ff_pull_last_run older than 15 min (only when attested) → the FF-pull cron is dead. */
  ff_cron_stale: boolean;
  repos: RepoGitHealth[];
  /** True once server.host_tombstone.is_host_tombstoned confirms this host's VM is
   * gone, or it's a manually-confirmed old name for a laptop that's since renamed —
   * a terminated-host artifact, not an ongoing incident. Was previously read only by
   * the backend's own summary roll-up; the detailed per-host panel list never
   * filtered on it, so a tombstoned host stayed visibly listed forever looking
   * identical to a live one (git_health_laptop_hostname_ghost_never_tombstoned_
   * 2026_08_19.md's follow-on gap). */
  is_tombstoned: boolean;
  /** When the tombstone check first confirmed this host was gone (detection time,
   * not necessarily the true termination/rename instant). Null when not tombstoned. */
  host_terminated_at: string | null;
}

export interface HostGitHealth {
  host: string;
  vm_id: string | null;
  slots: SlotGitHealth[];
}

export interface FleetGitHealthSummary {
  hosts: number;
  slots: number;
  repos_total: number;
  dirty: number;
  behind: number;
  ahead: number;
  diverged: number;
  clean: number;
  drift_violations: number;
  reporter_stale_slots: number;
  ff_cron_stale_slots: number;
}

/**
 * RootCloneStalenessCanary's last-observed facts for ONE root clone
 * (`unified-trading-pm` / `agent-orchestrator` at workspace_root(), NEVER a
 * `.tabs/N/` slot worktree) — the orchestrator VM's own deploy-currency clones
 * that every role prompt/RULES.md/skill boots from. Surfaced on the dashboard
 * (ao_root_pm_clone_11d_silent_freeze_canary_never_paged_2026_09_22.md item
 * (c), operator ask) because the 2026-09-22 incident sat 11 days stale with no
 * visible signal anywhere — this is the fleet git-health page's counterpart to
 * the per-slot repo rows above, for the two clones no slot walk ever covers.
 */
export interface RootCloneHealth {
  name: string;
  host: string;
  checked_at: string;
  branch: string;
  dirty: boolean;
  dirty_files: number;
  behind: number;
  /** Last tick this clone was observed caught-up (behind 0, not dirty). Null
   * until first observed caught-up since this process started. */
  ff_last_ok_at: string | null;
  /** A `.git/index.lock` older than the configured threshold with no live
   * holder — A28's measured root cause of the 11-day freeze; independent of
   * dirty/behind (blocks the later `merge --ff-only` write either way). */
  lock_stale: boolean;
  lock_age_minutes: number;
  local_sha: string | null;
  origin_sha: string | null;
}

export interface FleetGitHealthResponse {
  generated_at: string;
  scope: "local" | "fleet";
  summary: FleetGitHealthSummary;
  hosts: HostGitHealth[];
  drift_violations: Array<Record<string, string>>;
  vm_errors: Array<Record<string, string>>;
  /** Same threshold as StateResponse.git_red_sustain_secs — see there. */
  git_red_sustain_secs: number;
  /** RootCloneStalenessCanary's last tick for this backend's own root clones.
   * Empty until the canary's first tick (or on a keyless node that never runs
   * it — see server/routes/git_health.py). */
  root_clones: RootCloneHealth[];
}

// ── Fleet efficiency KPIs (AF-5, ao_fleet_observability_kpis_2026_07_20) ──────
// Mirrors server/fleet_kpis.py::kpis_as_dict / usage_as_dict + the GET
// /api/fleet-kpis envelope (server/routes/state.py). Null ratios are DELIBERATE
// (undefined when the denominator is 0 — never coerced to 0 or ∞ on the wire).

export interface FleetEfficiencyKpis {
  window_hours: number;
  boots: number;
  dispatches: number;
  done: number;
  /** Subset of `done` that closed via slot_done_orphan_task_closed rather than a plain slot_done. */
  orphan_done: number;
  conversion_pct: number;
  boots_per_done: number | null;
  dispatches_per_done: number | null;
  boots_to_dispatch_ratio: number | null;
  top_skip_reasons: Array<{ reason: string; count: number }>;
  skip_reason_coverage_note: string;
}

export interface FleetUsageAccount {
  account_id: string;
  transcript_bytes: number;
}

export interface FleetUsageEntry {
  label: string;
  account_id: string | null;
  transcript_bytes: number;
}

// ── Dispatch:done breakdown — per-slot / per-role / over-time + retry
// accounting. Mirrors server/fleet_kpis.py's SlotDispatchEfficiency /
// RoleDispatchEfficiency / DailyDispatchEfficiency / DispatchRetryStats.
// distinct_task_conversion_pct answers "of the tasks we actually touched, how
// many landed" — the event-count conversion_pct above conflates that with
// retries (a crashed/timed-out slot re-dispatches the SAME task).

export interface SlotDispatchEfficiency {
  /** Effective host this bucket belongs to. A `slot_id` is only unique WITHIN a
   * host, and the server keys these buckets by the COMPOSITE
   * `(effective_host, slot_id)` (server/fleet_kpis.py::SlotDispatchEfficiency),
   * so two hosts running the same slot number emit two rows carrying the SAME
   * `slot_id`. It is therefore part of the row's identity — key and label by
   * `FleetKpis.tsx::slotRowKey`/`slotRowLabel`, never a bare `slot_id`.
   * `null` only for a response built before this field existed (a live-queried
   * row always carries it); the same fail-safe nullability `SlotView.host` uses,
   * and `slotRowKey`/`slotRowLabel` default it to `central`. */
  host: string | null;
  slot_id: number | null;
  dispatches: number;
  done: number;
  /** Subset of `done` that closed via slot_done_orphan_task_closed (backlog
   * entry regenerated out from under a live dispatch) rather than a plain
   * slot_done — the worker still finished cleanly, just via a different path. */
  orphan_done: number;
  conversion_pct: number;
}

export interface RoleDispatchEfficiency {
  role: string;
  dispatches: number;
  done: number;
  /** See SlotDispatchEfficiency.orphan_done. */
  orphan_done: number;
  conversion_pct: number;
}

export interface DailyDispatchEfficiency {
  day: string;
  dispatches: number;
  done: number;
  conversion_pct: number;
}

export interface DispatchRetryStats {
  distinct_tasks_dispatched: number;
  distinct_tasks_done: number;
  redispatch_events: number;
  retry_rate_pct: number;
  distinct_task_conversion_pct: number | null;
}

// ── Fleet cost KPIs (2026-10-14) — the "dollars per done task" + "dollars per
// day" KPIs (ao_death_reasons_gate_starvation_and_cost_columns_findings_
// 2026_10_02 P1). Mirrors server/fleet_kpis.py's FleetCostKpis /
// DailyCostEfficiency + cost_kpis_as_dict / daily_cost_as_dict. The spend is
// the PRICED-row lower bound (raw list price over FLEET task rows only —
// human-session snapshot rows are excluded), never an all-or-nothing null:
// priced_coverage_pct says how much of the window the number covers.

export interface FleetCostKpis {
  window_hours: number;
  /** The same slot_done(+orphan) count the efficiency tiles use — the KPI's denominator. */
  done: number;
  fleet_priced_spend_usd: number;
  priced_task_count: number;
  /** fleet_priced_spend_usd / done; null when done === 0 — undefined, never 0. */
  dollars_per_done_task: number | null;
  /** priced / (priced + unpriced + unmeasured) fleet rows × 100; null when no rows. */
  priced_coverage_pct: number | null;
  priced_row_count: number;
  unpriced_row_count: number;
  unmeasured_row_count: number;
}

/** Mirrors DailyDispatchEfficiency's UTC-calendar-day shape, for the cost surface. */
export interface DailyCostEfficiency {
  day: string;
  done: number;
  fleet_priced_spend_usd: number;
  dollars_per_done_task: number | null;
  priced_coverage_pct: number | null;
  unpriced_row_count: number;
  unmeasured_row_count: number;
}

// Compaction/wedge KPIs (2026-08-15) — mirrors server/fleet_kpis.py's
// CompactionKpis / CraftCompactionEfficiency + compaction_kpis_as_dict /
// craft_compaction_breakdown_as_dict. craft_type distinguishes a genuine
// plan-backlog worker from an escalation/cicd/scheduled craft occupying the
// same role=="worker" bucket — see context_lifecycle.py's
// _TargetState.craft_type docstring.

export interface CompactionKpis {
  window_hours: number;
  forced_compact: number;
  forced_compact_ineffective: number;
  ineffective_pct_of_forces: number | null;
  context_wedge_recovered: number;
  wedge_rate_per_hr: number | null;
}

export interface CraftCompactionEfficiency {
  craft_type: string;
  forced_compact: number;
  forced_compact_ineffective: number;
  context_wedge_recovered: number;
  wedge_rate_per_hr: number | null;
}

/** Mirrors CraftCompactionEfficiency's shape, keyed by slot instead of craft_type.
 * See server/fleet_kpis.py's SlotCompactionEfficiency. */
export interface SlotCompactionEfficiency {
  slot_id: number | null;
  forced_compact: number;
  forced_compact_ineffective: number;
  context_wedge_recovered: number;
  wedge_rate_per_hr: number | null;
}

/** Mirrors DailyDispatchEfficiency's UTC-calendar-day shape, for the
 * compaction surface. See server/fleet_kpis.py's DailyCompactionEfficiency. */
export interface DailyCompactionEfficiency {
  day: string;
  forced_compact: number;
  forced_compact_ineffective: number;
  context_wedge_recovered: number;
  wedge_rate_per_hr: number | null;
}

/** Per-role classification of dispatched-but-not-"done"-by-event task_ids —
 * of a role's reported shortfall, how much is a no-op (cancelled / still
 * in-flight) vs genuinely unexplained. See server/fleet_kpis.py's
 * RoleNoOpTaskBreakdown for the bucket-priority rule. */
export interface RoleNoOpTaskBreakdown {
  role: string;
  distinct_dispatched: number;
  distinct_done: number;
  cancelled: number;
  still_in_flight: number;
  unexplained: number;
}

// Fleet slot utilization (2026-08-15) — "are we using most of our fleet's slots
// right now, and how does that compare to ~24 hours ago?". Mirrors
// server/fleet_utilization.py's FleetUtilization + utilization_as_dict. Framed as
// "how BUSY" the fleet is (a number that reads close to 100 when healthy) — the
// inverse of HealthSummary.idleAvailable (layout.tsx), per the operator's own
// stated preference. current_pct/baseline_pct are null only when there were zero
// eligible (non-paused) worker slots on that side — never a misleading 0%.
// has_baseline is false only when no snapshot row exists yet at all (e.g. the
// snapshot poller was only just deployed), independent of whether the pct itself
// is null.
export interface FleetUtilization {
  current_pct: number | null;
  baseline_pct: number | null;
  delta_pct: number | null;
  has_baseline: boolean;
  baseline_hours: number;
  baseline_ts: string | null;
}

export interface FleetKpisResponse {
  efficiency: FleetEfficiencyKpis;
  baseline: FleetEfficiencyKpis;
  regression_alert: string | null;
  usage: {
    by_account: FleetUsageAccount[];
    entries: FleetUsageEntry[];
  };
  by_slot: SlotDispatchEfficiency[];
  by_role: RoleDispatchEfficiency[];
  role_breakdown_coverage_note: string;
  by_role_no_op: RoleNoOpTaskBreakdown[];
  by_day: DailyDispatchEfficiency[];
  cost: FleetCostKpis;
  cost_baseline: FleetCostKpis;
  cost_by_day: DailyCostEfficiency[];
  retry_stats: DispatchRetryStats;
  compaction: CompactionKpis;
  compaction_baseline: CompactionKpis;
  compaction_by_craft_type: CraftCompactionEfficiency[];
  compaction_by_slot: SlotCompactionEfficiency[];
  compaction_by_day: DailyCompactionEfficiency[];
  utilization: FleetUtilization;
}

// CPU/RAM/disk snapshot pushed over /ws/vm-resources every 5s
// (ao_planning_vm_resource_monitor_2026_07_27). Every field is best-effort
// None when its underlying /proc probe is unreadable — never a hard failure.
export interface HostResources {
  cpu_percent: number | null;
  cpu_count: number;
  iowait_percent: number | null;
  load_avg_1m: number | null;
  load_avg_5m: number | null;
  load_avg_15m: number | null;
  ram_used_bytes: number | null;
  ram_total_bytes: number | null;
  ram_percent: number | null;
  swap_used_bytes: number | null;
  swap_total_bytes: number | null;
  swap_percent: number | null;
  disk_used_bytes: number | null;
  disk_total_bytes: number | null;
  disk_percent: number | null;
  // 2026-09-02 staleness fields, computed server-side by resource_history.latest_from_disk()
  // against "now" — `stale` is honest, never inferred client-side from a missing update.
  sampled_at: string | null;
  stale: boolean;
  stale_reason: string | null;
}

// GET /api/hosts/capacity (server/routes/hosts.py::list_hosts_capacity) — one row per
// AO-backend host (central + every v2 node), host-resources-panel-blank-and-multihost-
// table_2026_09_09 / ao_fleet_slot_resource_ui_and_scale_controls_2026_09_05.md todo 2.
export interface HostCapacityRowView {
  host_id: string;
  label: string | null;
  is_central: boolean;
  ever_reported: boolean;
  slots_total: number;
  slots_reporting_resources: number;
  host_cpu_pct: number | null;
  host_cpu_count: number | null;
  host_ram_pct: number | null;
  host_ram_used_bytes: number | null;
  host_ram_total_bytes: number | null;
  host_ram_free_bytes: number | null;
  host_disk_pct: number | null;
  host_disk_used_bytes: number | null;
  host_disk_total_bytes: number | null;
  host_disk_free_bytes: number | null;
  host_swap_pct: number | null;
  host_swap_used_bytes: number | null;
  host_swap_total_bytes: number | null;
  host_swap_free_bytes: number | null;
  host_telemetry_supported: boolean | null;
  stale: boolean;
  stale_reason: string | null;
  sampled_at: string | null;
}

export interface HostsCapacityResponse {
  ok: boolean;
  hosts: HostCapacityRowView[];
}

// POST /api/hosts/{host_id}/slots/scale (server/routes/hosts.py::scale_host) —
// ao_fleet_slot_resource_ui_and_scale_controls_2026_09_05.md todo 3 (R17). The
// actuation itself is asynchronous (the next heartbeat/dispatch tick), so this
// response IS "what will happen before it happens" — never a synchronous guarantee.
export interface ScaleHostResponse {
  ok: boolean;
  host_id: string;
  target_slot_count: number;
  /** The host's own last-declared range — the hard ceiling a target can never exceed. */
  slots_total: number;
  /** Currently-idle slots that just became eligible — start on the NEXT dispatch tick
   * if backlog demand exists, never synchronously with this call. */
  newly_eligible_slot_ids: number[];
  /** Currently-BUSY slots beyond the new target — never torn down while running;
   * retire the moment each next reports idle. A non-empty list here is the "graceful
   * scale-down, not an apparent no-op" signal the plan's own done-when requires. */
  draining_slot_ids: number[];
  /** Currently-IDLE slots beyond the new target — retire on the NEXT heartbeat. */
  retiring_now_slot_ids: number[];
}

// GET /api/hosts/{host_id}/resource-history — the durable series behind a node's
// row in the table above (host-resources-panel-blank-and-multihost-table_2026_09_09
// follow-up: "are those stats written somewhere so we can have proper history").
// Node-only — central has no rows here (see the endpoint's own docstring).
export interface NodeResourceHistoryPointView {
  sampled_at: string;
  host_cpu_pct: number | null;
  host_ram_pct: number | null;
  host_disk_pct: number | null;
}

export interface NodeResourceHistoryResponse {
  host_id: string;
  points: NodeResourceHistoryPointView[];
}

export type AccountTier = "pro" | "max5" | "max20" | "team" | "enterprise" | "api" | "glm_coding_max";

// Runtime twin of AccountTier for the tier-editor dropdown. Mirrors
// server/accounts.py ACCOUNT_TIERS — keep the two in sync.
export const ACCOUNT_TIERS: readonly AccountTier[] = [
  "pro",
  "max5",
  "max20",
  "team",
  "enterprise",
  "api",
  "glm_coding_max",
];
export type AccountStatus = "healthy" | "high_usage" | "rate_limited" | "auth_failed" | "disabled";

export type AccountProvider = "anthropic" | "deepseek" | string;

export interface AccountView {
  account_id: string;
  label: string;
  tier: AccountTier | string;
  /** "anthropic" | "deepseek", from accounts.json
   * (deepseek_claude_blended_provider_routing_2026_07_28 [UI] P1). */
  provider: AccountProvider;
  primary_email: string | null;
  weekly_msg_limit: number;
  weekly_msgs_used: number;
  weekly_window_start: string | null;
  five_hour_msgs_used: number;
  five_hour_window_start: string | null;
  rate_limited_until: string | null;
  last_used_at: string | null;
  last_used_by_slot: number | null;
  status: AccountStatus;
  used_by_slots: number[];
  // Authoritative percentages parsed from `claude /usage`. Prefer these
  // for bar fills + labels; fall back to msgs/limit ratio when null.
  weekly_pct: number | null;
  five_hour_pct: number | null;
  weekly_sonnet_msgs_used: number;
  weekly_sonnet_pct: number | null;
  // Window-start + period, computed on the server. Render as "resets in Xd Yh".
  weekly_resets_at: string | null;
  five_hour_resets_at: string | null;
  // Extra unified rate-limit header telemetry (API probe path; null until probed).
  // Operator-facing detail, shown as plain text — not charted.
  unified_status: string | null; // "allowed" | "allowed_warning" | "rejected"
  representative_claim: string | null; // binding window, e.g. "five_hour"
  overage_status: string | null; // "allowed" | "rejected"
  overage_disabled_reason: string | null; // e.g. "out_of_credits"
  upgrade_paths: string | null; // e.g. "upgrade_plan"; mostly only sent on a 429
  // `tier` is operator-declared and unverifiable (no endpoint an OAuth setup-token can
  // reach exposes the plan), so a downgrade is otherwise invisible. True = this account
  // declares a top tier but the API offered it an upgrade — a prompt to VERIFY, not a
  // proven mismatch. Render it as a question, never as a fact.
  tier_contradicted: boolean;
  // Phase 4c: long-lived setup-token expiry (r3 accounts).
  // setup_token_alert: null (no expiry tracked) | "ok" | "warn" (≤30d) | "crit" (≤7d) | "expired"
  setup_token_expires_at: string | null;
  setup_token_expires_in_days: number | null;
  setup_token_alert: "ok" | "warn" | "crit" | "expired" | null;
  // DeepSeek dollar balance (deepseek_claude_blended_provider_routing_2026_07_28
  // follow-up, 2026-08-04). DeepSeek's API exposes only REMAINING balance, never
  // spend history — "available", never "used vs available" (operator decision,
  // same date). All null for a non-deepseek account, or before the first poll tick.
  balance_usd: number | null;
  balance_currency: string | null;
  balance_is_available: boolean | null;
  balance_checked_at: string | null;
  // Real $ spend + token usage, derived from transcript files (deepseek_usage.py,
  // 2026-08-05 follow-up — operator ruling: show actual spend, not balance-only;
  // DeepSeek has no spend-history API at all, unlike balance_* above). null for a
  // non-deepseek account, or before DeepSeekUsagePoller's first tick.
  deepseek_usage: DeepSeekUsageSummary | null;
  // Operator-declared, evidence-backed per-account health flag — distinct from
  // `status` above, which reflects pause/rate-limit/auth state, not "does this
  // specific model actually respond". gemma_4_31b_it_persistent_timeout_2026_08_19:
  // NVIDIA registers each Gemma variant as its own account; one variant has a real,
  // reproduced zero-byte-timeout failure while its sibling is proven working, and
  // `status` can't carry that (both are independently paused for an unrelated
  // reason). null = not tracked — no banner, not an unhealthy claim.
  health_status: "healthy" | "degraded" | null;
  // The vendor's own reason its quota endpoint gave no readable window (GLM team seats:
  // "current user has no coding plan"). null = a reading exists or never polled; when set,
  // weekly_pct/five_hour_pct are null.
  quota_unavailable_reason: string | null;
  // AO-ledger ESTIMATE of a GLM TEAM seat's rolling-7d credit usage as a % of its declared
  // weekly_credit_limit. null = no such ceiling (every non-team account). Deliberately NOT
  // weekly_pct: that gates dispatch, and an estimate must never reach it. Render it plainly
  // labelled as an estimate — Z.ai exposes no team meter by API, so there is no vendor bar.
  weekly_estimate_pct?: number | null;
  // Gemini free-tier RPM/RPD/TPM headroom (model_provider_badge_mismatch_2026_08_21
  // [UI] P1 follow-up) — the real ceiling shape for Gemini, a raw request-rate quota,
  // NOT the Claude-shaped weekly/5-hour subscription fields above. All null for a
  // non-gemini account, or a gemini account whose variant has no registered ceiling.
  gemini_rpm_used: number | null;
  gemini_rpm_ceiling: number | null;
  gemini_rpd_used: number | null;
  gemini_rpd_ceiling: number | null;
  // "vendor" (real Cloud Monitoring read, 2026-08-24) | "self_count" (AO's own
  // spawn-selection count, measured ~150x undercounted that day) | null for a
  // non-gemini account.
  gemini_rpd_source: string | null;
  gemini_tpm_ceiling: number | null;
  // Token family (2026-08-26): Google's granted input tokens in the latest reported
  // minute vs the ceiling, the peak minute in the recent window, token-quota 429s in
  // that window; "vendor" | "none" | null (non-gemini). No local self-count exists.
  gemini_tpm_used: number | null;
  gemini_tpm_peak_recent: number | null;
  gemini_tpm_rejected_recent: number | null;
  gemini_tpm_source: string | null;
}

export interface DeepSeekUsageWindow {
  input_tokens: number;
  output_tokens: number;
  cache_creation_input_tokens: number;
  cache_read_input_tokens: number;
  spend_usd: number;
  // $ spend split by pricing tier — cache_creation bills at the noncache rate, so it
  // folds into input_noncache_spend_usd (2026-08-05 breakdown follow-up).
  input_noncache_spend_usd: number;
  input_cache_spend_usd: number;
  output_spend_usd: number;
  // Per-turn efficiency + per-task stats (deepseek_flash_ab_routing_test_2026_08_05
  // follow-up) — turn_count is this window's turn count; task_count/avg_turns_per_
  // task/avg_context_tokens_per_task are sourced from completed tasks on this
  // account. null fields mean nothing to divide by (turn_count or task_count is 0).
  turn_count: number;
  task_count: number;
  avg_turns_per_task: number | null;
  avg_context_tokens_per_task: number | null;
  input_tokens_per_turn: number | null;
  cache_creation_tokens_per_turn: number | null;
  cache_read_tokens_per_turn: number | null;
  output_tokens_per_turn: number | null;
  spend_per_turn: number | null;
  // DeepSeek native-proxy reasoning-token breakdown (deepseek_native_usage_
  // reasoning_tokens_visibility_2026_08_12) — sourced from DeepSeekNativeUsageRow,
  // scoped directly to this account (this whole surface is DeepSeek-only, so no
  // claude_session_id join is needed here). NOT additive spend — a subset WITHIN
  // output_tokens, per DeepSeek's own accounting (no separate reasoning rate).
  // Optional/null: older backends omit it (a cached deepseek_usage_json blob written
  // before this field existed), or zero DeepSeekNativeUsageRow rows exist in this
  // window (no native capture at all) — never a misleading 0.
  reasoning_tokens?: number | null;
  reasoning_tokens_per_turn?: number | null;
}

export interface DeepSeekUsageSummary {
  updated_at: string;
  one_hour: DeepSeekUsageWindow;
  five_hour: DeepSeekUsageWindow;
  day: DeepSeekUsageWindow;
  week: DeepSeekUsageWindow;
  lifetime: DeepSeekUsageWindow;
}

// GET /api/accounts/deepseek/topups — one recorded real top-up on the shared
// DeepSeek wallet (deepseek_flash_ab_routing_test_2026_08_05 follow-up).
export interface DeepSeekTopupView {
  id: number;
  amount_usd: number;
  recorded_at: string;
  note: string | null;
}

// GET /api/accounts/deepseek/wallet-reconciliation — "where did the money go" for
// the ONE real wallet backing every deepseek-provider account. worker/orchestrator/
// review are ONLY ever computed from correctly-attributed rows (account_id == model).
// residual_usd is null until the operator records at least one top-up.
// opening_balance_usd = the frozen pre-observability gap (operator-recorded; null
// until then); residual_since_observability_usd = residual - opening_balance — the
// LIVE leak signal, distinguishable from frozen history
// (deepseek_wallet_residual_root_cause_and_windowed_reconciliation_2026_08_11 P2).
export interface DeepSeekWalletReconciliationView {
  known_topup_total_usd: number;
  topup_count: number;
  current_balance_usd: number | null;
  real_total_spend_usd: number | null;
  worker_spend_usd: number;
  orchestrator_spend_usd: number;
  review_spend_usd: number;
  scheduled_spend_usd: number;
  escalation_spend_usd: number;
  attributed_total_usd: number;
  residual_usd: number | null;
  opening_balance_usd: number | null;
  opening_balance_note: string | null;
  residual_since_observability_usd: number | null;
}

// GET /api/accounts/deepseek/wallet-reconciliation/window?window_hours= — the same
// wallet question bounded to a real window instead of all time (deepseek_wallet_
// residual_root_cause_and_windowed_reconciliation_2026_08_11 P2). real_spend_usd/
// residual_usd are null whenever the balance series does not yet reach back to
// window_start — series_starts_at (the oldest sample) tells the caller when it will.
// balance_at_{start,end}_sampled_at are the ACTUAL sample timestamps, which can differ
// slightly from window_start/window_end (see DeepSeekWalletWindowReconciliation's SKEW
// note server-side) — both are surfaced so the true differenced span is visible.
export interface DeepSeekWalletWindowReconciliationView {
  window_hours: number;
  window_start: string;
  window_end: string;
  balance_at_start_usd: number | null;
  balance_at_start_sampled_at: string | null;
  balance_at_end_usd: number | null;
  balance_at_end_sampled_at: string | null;
  topups_in_window_usd: number;
  real_spend_usd: number | null;
  worker_spend_usd: number;
  orchestrator_spend_usd: number;
  review_spend_usd: number;
  scheduled_spend_usd: number;
  escalation_spend_usd: number;
  attributed_total_usd: number;
  residual_usd: number | null;
  series_starts_at: string | null;
}

/** GET /api/accounts/gemini/capacity -- real, live RPM/RPD consumption for a Gemini
 * account vs its declared ceiling (2026-08-16, ao_open_work_consolidated_tracker "build
 * the rest now"). A null ceiling means an unregistered `variant`, not a fabricated 0/0 --
 * see the backend `GeminiAccountCapacity` docstring. TPM (2026-08-26) is vendor-only:
 * `tpm_used` = Google's granted input tokens in the latest reported minute, `tpm_peak_recent`
 * = the largest minute in the recent window, `tpm_rejected_recent` = token-quota 429s in
 * that window — all null with `tpm_source: "none"` when the token read was unavailable. */
export interface GeminiAccountCapacityView {
  account_id: string;
  label: string;
  variant: string | null;
  gcp_project: string | null;
  rpm_used: number;
  rpm_ceiling: number | null;
  rpd_used: number;
  rpd_ceiling: number | null;
  // "vendor" (real Cloud Monitoring read, 2026-08-24) | "self_count" (the local
  // spawn-selection count, measured ~150x undercounted that day).
  rpd_source: string;
  tpm_ceiling: number | null;
  tpm_used: number | null;
  tpm_peak_recent: number | null;
  tpm_rejected_recent: number | null;
  // "vendor" | "none"
  tpm_source: string;
}

/** GET /api/accounts/nvidia/capacity -- real, live RPM consumption for the shared NVIDIA
 * key vs ceiling (2026-08-16, ao_open_work_consolidated_tracker "build the rest now"). ONE
 * shared reading across every NVIDIA account, not one row per account -- see the backend
 * `NvidiaCapacitySnapshot` docstring for why. `ceiling_confirmed=false` means the RPM figure
 * is a community-reported baseline, not yet empirically measured against this fleet's own
 * key. `null` (not an empty object) when no NVIDIA accounts are registered. */
export interface NvidiaCapacityView {
  rpm_used: number;
  rpm_ceiling: number;
  ceiling_confirmed: boolean;
  account_ids: string[];
  account_labels: string[];
}

/** GET /api/accounts/muse/capacity -- the shared Muse team's real, live RPM
 * consumption vs Meta's published contributor-tier ceiling
 * (muse_spark_provider_addition_2026_08_25). Mirrors NvidiaCapacityView -- ONE
 * shared reading across every muse account, not one row per account.
 * `ceiling_confirmed=false` means the 100 RPM figure is Meta's own official
 * published number, not yet empirically measured against this fleet's own key.
 * `null` (not an empty object) when no muse accounts are registered. */
export interface MuseCapacityView {
  rpm_used: number;
  rpm_ceiling: number;
  ceiling_confirmed: boolean;
  account_ids: string[];
  account_labels: string[];
  // Real vendor-reported capacity from the freshest MuseQuotaPoller reading
  // (muse_spark_provider_addition_2026_08_25 Phase 3) -- a DIFFERENT source than
  // rpm_used/rpm_ceiling above (a live x-ratelimit-* header read vs Meta's separately
  // published 100 RPM/team figure), carrying no known window duration. null until the
  // poller has ticked at least once.
  real_requests_remaining: number | null;
  real_requests_limit: number | null;
  real_tokens_remaining: number | null;
  real_tokens_limit: number | null;
  real_quota_checked_at: string | null;
  ceiling_hit_count_24h: number;
}

/** GET /api/accounts/concurrency-caps (fleet-wide list) and
 * GET /api/slots/{slot_id}/concurrency-cap (per-slot, nullable) -- wire view of one
 * server/concurrency_caps.py CapStatus reading (cost_ranked_model_routing_rebuild_
 * 2026_08_28.md Phase 2). `scope` is "account" (per-account, GLM/Anthropic), "fleet"
 * (provider-wide, Gemini/Muse), or "project" (Gemini per-GCP-project); `key` identifies
 * the scoped entity -- an account_id for "account", the bare provider for "fleet", or
 * "{provider}:{project}" for "project". `at_cap` (`active >= cap`) and `over_cap`
 * (`active > cap`) are both the backend's own verdicts, never re-derived client-side:
 * `at_cap` means "no headroom left", which for a repo or account is the NORMAL steady
 * state, while `over_cap` means the ceiling was genuinely breached (the anomaly the
 * concentration watchdog pages on). */
/** GET /api/accounts/concurrency-cap-knobs -- the editable CONFIGURATION behind the
 * ConcurrencyCapView readings above. `default` is the shipped code value; `effective`
 * is what the picker actually enforces right now; they differ only when `overridden`. */
export interface ConcurrencyCapKnobView {
  knob: string;
  label: string;
  scope: string;
  provider: string;
  default: number;
  effective: number;
  overridden: boolean;
  updated_at?: string | null;
  updated_by?: string | null;
}

export interface ConcurrencyCapView {
  scope: string;
  key: string;
  provider: string;
  cap: number;
  active: number;
  at_cap: boolean;
  over_cap: boolean;
}

/** GET /api/accounts/flat-rate-boost -- the same flat-rate billing calibration as
 * Claude's, for every declared GLM/Codex account (2026-08-16, ao_open_work_
 * consolidated_tracker "build now, dormant" plumbing). `boost_multiplier` is None for
 * EVERY row today -- no poller yet reads a weekly_pct-equivalent signal from either
 * vendor's API, an honest "no data yet" state, not a bug -- see the backend
 * `FlatRateBoostReconciliation` docstring. */
export interface FlatRateBoostReconciliationView {
  account_id: string;
  label: string;
  provider: string;
  // Shared api_key_secret_name for accounts on the SAME real subscription; null when
  // unpriced. Every account sharing one carries the IDENTICAL (undivided)
  // monthly_price_usd/subscription_spend_usd/metered_equivalent_spend_usd/
  // boost_multiplier -- dedupe by this key when aggregating a provider total, or a
  // shared bill is summed once per alias instead of once per real account
  // (glm_second_subscription_account_billing_split_2026_08_30).
  billing_group_key: string | null;
  monthly_price_usd: number | null;
  window_start: string | null;
  window_end: string;
  now: string;
  window_is_complete: boolean;
  // True when window_start is a synthetic `now - 7d` fallback (no real
  // vendor-reported window boundary exists yet for this group) rather than an actual
  // observed reset boundary -- render this row as an unverified estimate, not a
  // normal measured window (ao_billing_provider_aggregate_residuals_2026_08_31 item 6).
  synthetic_window: boolean;
  weekly_pct: number | null;
  subscription_spend_usd: number | null;
  metered_equivalent_spend_usd: number | null;
  unpriced_turns: number;
  boost_multiplier: number | null;
  // True when the denominator is the AO-ledger credit ESTIMATE (a Z.ai team seat has
  // no vendor weekly_pct at all). Label it "(est.)"; never present it as measured.
  boost_multiplier_estimated?: boolean;
}

// GET /api/accounts/claude/wallet-reconciliation — flat-rate billing calibration for
// every declared Anthropic-subscription account (claude_anthropic_flat_rate_billing_
// calibration_2026_08_12). Two numbers named for what they literally are (operator
// correction 2026-08-13 — an earlier implied/actual naming read backwards from how
// anyone actually thinks about a subscription bill):
//   subscription_spend_usd       = the REAL dollar figure, from Anthropic's own
//                                   %-of-weekly-limit signal x prorated subscription fee
//                                   — what you actually pay.
//   metered_equivalent_spend_usd = captured tokens priced at Anthropic's METERED list
//                                   rates — a HYPOTHETICAL figure, what the bill would be
//                                   if billed per-token instead of flat.
// boost_multiplier = metered_equivalent/subscription (metered_equivalent_spend_usd is
// always the LARGER number — flat-rate subscriptions are cheap relative to metered API
// pricing by design; a real production account read metered_equivalent=$1455.53 vs
// subscription=$45.16, a ~32x boost); null whenever either side is unknown (no /usage
// probe yet, untiered account, or an unpriced/zero-spend window) — never fabricated.
export interface ClaudeAccountWalletReconciliationView {
  account_id: string;
  label: string;
  tier: string;
  primary_email: string | null;
  monthly_price_usd: number | null;
  window_start: string | null;
  window_end: string;
  now: string;
  window_is_complete: boolean;
  weekly_pct: number | null;
  subscription_spend_usd: number | null;
  metered_equivalent_spend_usd: number | null;
  unpriced_turns: number;
  boost_multiplier: number | null;
}

// GET /api/accounts/claude/wallet-reconciliation/window?window_hours= — the windowed
// counterpart to ClaudeAccountWalletReconciliationView above: one row per account,
// bounded by an explicit window_hours (le 2160 = 90 days) instead of each account's own
// differently-timed weekly reset. reset_crossed flags a window whose delta was chained
// across one or more weekly resets (server/state_store/account_usage.py::
// _weekly_pct_delta_across_resets) — correct in aggregate, but a mid-window tier/account
// change is not yet tracked per-segment (multi_provider_context_billing_reconciliation_
// 2026_08_16, open todo), so a reset_crossed row is the one case still worth a manual
// sanity-check rather than trusting the multiplier outright.
export interface FlatRateBoostWindowReconciliationView {
  account_id: string;
  label: string;
  provider: string;
  billing_group_key: string | null;
  monthly_price_usd: number | null;
  window_hours: number;
  requested_window_start: string;
  requested_window_end: string;
  start_sample_at: string | null;
  end_sample_at: string | null;
  reset_crossed: boolean;
  subscription_spend_usd: number | null;
  metered_equivalent_spend_usd: number | null;
  unpriced_turns: number;
  boost_multiplier: number | null;
}

export interface ClaudeAccountWalletWindowReconciliationView {
  account_id: string;
  label: string;
  tier: string;
  primary_email: string | null;
  monthly_price_usd: number | null;
  window_hours: number;
  requested_window_start: string;
  requested_window_end: string;
  start_sample_at: string | null;
  end_sample_at: string | null;
  reset_crossed: boolean;
  tier_changed_mid_window: boolean;
  subscription_spend_usd: number | null;
  metered_equivalent_spend_usd: number | null;
  unpriced_turns: number;
  boost_multiplier: number | null;
}

// GET /api/backlog/usage/top-tasks — completed tasks RANKED by cost
// (server/models/backlog.py::TopTaskCostView). The per-TASK counterpart of the
// windows endpoint below: "where is the spend concentrated" answered by an ORDERING
// rather than by an aggregate (anthropic_per_task_actual_spend_and_account_
// calibration_2026_08_10 [BACKEND] P2).
//
// list_value_usd is LIST-priced value (published per-token API rates) summed over the
// task's attempt rows, and is null whenever ANY attempt row is unpriced — never a
// partial sum, which would understate the task AND silently reorder the ranking.
//
// Ranking by list value is deliberate, not a shortcut: a flat-rate plan's measured
// value multiplier divides every task in a window by the SAME constant, so it cancels
// out of the ordering entirely. That is what lets the ranking ship while the
// subscription calibration is still not converged — only the absolute figure depends
// on it, which is exactly what absolute_is_provisional labels.
export interface TopTaskCostView {
  task_id: string;
  provider: string | null;
  model: string | null;
  attempt_count: number;
  unpriced_row_count: number;
  turn_count: number;
  input_tokens: number;
  output_tokens: number;
  cache_creation_input_tokens: number;
  cache_read_input_tokens: number;
  list_value_usd: number | null;
  // The provider's PUBLISHED billing shape
  // (server/model_pricing.py::billing_shape_for_provider), not a private vocabulary:
  // "metered_dollar" is a real per-token charge (cash); every subscription shape
  // needs a measured multiplier before it is spend; "rate_limited_free" was never
  // billed per token; null = provider not categorised yet. Rendered by
  // spendBasisLabel() in TaskUsageWindows.tsx.
  spend_basis: string | null;
  // True whenever list_value_usd is NOT real cash — see spend_basis above. Never
  // false-by-default: a reader must be able to tell "what we paid" from "list value".
  absolute_is_provisional: boolean;
  last_completed_at: string;
}

// GET /api/backlog/usage/windows — rolling-window aggregate over TaskUsageRow
// (server/models/backlog.py::TaskUsageWindowView), one entry per window
// ("1h"/"5h"/"24h"/"7d"/"lifetime"), any provider (2026-08-05 per-task token-
// breakdown follow-up: "tokens per task, over time" operator ask).
export interface TaskUsageWindowView {
  window: string;
  input_tokens: number;
  cache_creation_input_tokens: number;
  cache_read_input_tokens: number;
  output_tokens: number;
  spend_usd: number | null;
  // Count of rows THIS window's null spend_usd stands in for — fleet-dominant case is
  // an Anthropic/Claude row (no price table entry at all), not a data gap. Lets the UI
  // render "— (N unpriced)" instead of a bare dash that reads as broken
  // (ao_fleet_health_investigation_followups_2026_08_06).
  unpriced_row_count: number;
  // Count of rows in this window whose spend/cache-read numbers are the 98%-cache-
  // fraction APPROXIMATION (codex_historical_cache_estimate_2026_08_24), not real
  // per-turn ledger data — see server orm.py TaskUsageRow.pricing_is_estimated's own
  // docstring. Unlike unpriced_row_count this does NOT null spend_usd; it just flags
  // the cell as a rougher number (see estimatedCellTitle/fmtUsdOrDashWithEstimateFlag
  // in TaskUsageWindows.tsx).
  estimated_row_count: number;
  // Count of rows in this window with TaskUsageRow.died_mid_task=True — a session
  // killed before ever reaching /done (task_usage_cost_tracking_gaps_2026_08_27
  // [BACKEND] P1). Included in every other total by default (real captured spend);
  // the "Hide died mid-task" filter chip (server-side exclude_died_mid_task) drops
  // them from every total when toggled on.
  died_mid_task_row_count: number;
  task_count: number;
  avg_tokens_per_task: number | null;
  avg_spend_per_task: number | null;
  // Per-turn efficiency (deepseek_flash_ab_routing_test_2026_08_05 follow-up) — "how
  // many turns does a task take, and where do those turns' tokens go" — a raw
  // avg-tokens-per-task can't tell a 500-turn outlier from ten 50-turn tasks.
  turn_count: number;
  avg_turns_per_task: number | null;
  input_tokens_per_turn: number | null;
  cache_creation_tokens_per_turn: number | null;
  cache_read_tokens_per_turn: number | null;
  output_tokens_per_turn: number | null;
  spend_per_turn: number | null;
  // DeepSeek native-proxy reasoning-token breakdown (deepseek_native_usage_
  // reasoning_tokens_visibility_2026_08_12), joined by claude_session_id against
  // DeepSeekNativeUsageRow — see TaskUsageView.reasoning_tokens for the null-vs-zero
  // contract. null when NOT ONE task in this window has a matching native-usage row
  // (never a 0). reasoning_tokens_per_turn is null whenever turn_count is 0 OR
  // reasoning_tokens itself is null.
  reasoning_tokens: number | null;
  reasoning_tokens_per_turn: number | null;
  // provider_concurrency_backoff_alerting_parity_2026_08_27 [BACKEND] P2: derived
  // decode throughput — output_tokens ÷ wall-clock seconds aggregated over timed
  // rows in this window, directly comparable to Z.ai's public "Peak avg Decode"
  // (~85-120 t/s Max&Pro, ~65-95 t/s Lite 2026-08-21..27, reference only — NOT a cap).
  output_tokens_per_second: number | null;
  // anthropic_per_task_actual_spend_and_account_calibration_2026_08_10 [UI] P2: the
  // provider's published billing shape (server/model_pricing.py::billing_shape_for_
  // provider) — same vocabulary as TopTaskCostView.spend_basis above, rendered by the
  // same spendBasisLabel(). null when this window is unscoped (no ?provider= filter)
  // and therefore potentially mixed-shape.
  spend_basis: string | null;
  // Lower bound that never blanks: sum of every priced row in the window, and the count
  // of node-tombstone rows (unmeasured_reason set) that are excluded from
  // unpriced_row_count and no longer null spend_usd. Rendered "at least $X, N unmeasured"
  // (see spendLowerBoundText in TaskUsageWindows.tsx).
  priced_spend_usd?: number | null;
  unmeasured_row_count?: number;
}

// GET /api/backlog/usage/hourly-series — hourly, FIXED-UTC-clock-hour-bucketed
// usage/dispatch-attempt time series per (provider, role_group)
// (server/models/backlog.py::HourlyUsageBucketView) — 2026-08-18 operator ask: plot
// usage over time per provider, broken down by role, to spot burst patterns and
// repeated-dispatch-without-landing account contention. `hour` is a FIXED UTC
// clock-hour boundary (00:00, 01:00, ...), never a trailing "last N hours from now"
// window like every other `window` field on this page — a deliberately different
// shape, see the endpoint's own docstring.
export interface HourlyModelRateView {
  model: string;
  input_usd: number | null;
  output_usd: number | null;
}

export interface HourlyUsageBucketView {
  hour: string; // ISO 8601 UTC clock-hour boundary
  provider: string;
  role_group: string;
  task_count: number; // completions
  dispatch_attempts: number; // task_dispatched events — the "trying repeatedly" signal
  input_tokens: number;
  cache_creation_input_tokens: number;
  cache_read_input_tokens: number;
  output_tokens: number;
  spend_usd: number | null;
  /** The coverage split behind spend_usd's null-ness — "X of Y runs metered".
   * Denominator is priced + unpriced (both counted per TaskUsageRow, so they always
   * sum to the rows that reached the money accounting). NOT task_count: that is
   * DISTINCT task_id, and one task contributes several usage rows. */
  priced_row_count: number;
  unpriced_row_count: number;
  rates: HourlyModelRateView[];
}

// GET /api/backlog/usage/shadow-comparison — one persisted UsagePoller tick's
// cost-ranked shadow-dispatch-comparison aggregate (server/models/backlog.py::
// RoutingShadowComparisonSummaryView, routing_decision_visibility_gap_2026_09_01).
// A tick with zero real completions in its window logs no row at all — this list
// only ever contains ticks that actually sampled something.
export interface RoutingShadowComparisonSummaryView {
  id: number;
  ts: string; // ISO 8601 UTC
  sampled: number;
  resolved: number;
  would_have_differed: number;
  actual_total_usd: number;
  shadow_total_usd: number;
}

// GET /api/backlog/usage/shadow-comparison/live — one real completed task replayed
// LIVE through the cost-ranked pipeline (server/models/backlog.py::
// RoutingShadowComparisonRowView). Computed ON DEMAND at request time, never
// persisted — always reflects TODAY's live account pool and rate cards, not the
// pool that existed when the task actually ran. shadow_* fields are null when the
// pipeline could not resolve any pick at all (e.g. an empty account pool).
export interface RoutingShadowComparisonRowView {
  task_id: string;
  role: string;
  actual_model: string;
  actual_cost_usd: number | null;
  shadow_model: string | null;
  shadow_account_id: string | null;
  shadow_cost_usd: number | null;
  would_have_differed: boolean;
}

// GET /api/backlog/batching-stats/windows — rolling-window tool-call-batching
// efficiency (server/models/backlog.py::BatchingStatsWindowView), fleet-wide across
// every session regardless of provider/account/slot. "Is the batching-nudge hook
// actually working" (2026-08-14 follow-up: "make the number itself visible and
// recurring"). Read from BatchingStatsPoller's precomputed rollup, not a live scan —
// a full fleet scan takes minutes.
export interface BatchingStatsWindowView {
  window: string;
  turns: number;
  tool_calls: number;
  avg_tool_calls_per_turn: number | null;
  zero_tool_turns: number;
  single_tool_turns: number;
  multi_tool_turns: number;
  // The headline efficiency number — 2+ tool calls bundled into one turn means the
  // batching nudge/block worked; a rising trend across windows is direct evidence
  // (operator target: 50% ABSOLUTE, not relative-to-baseline — see
  // BatchingEfficiencyPanel.tsx for why that distinction matters for this field only).
  multi_tool_turn_pct: number | null;
  output_tokens: number;
  output_tokens_per_turn: number | null;
  bash_calls: number;
  bash_chained_segments: number;
  // Commands chained per Bash call (&&/; inside one call) — the second efficiency axis,
  // operator target: relative +50% (2.50 -> 3.75), NOT absolute like multi_tool_turn_pct.
  avg_commands_per_bash_call: number | null;
}

// GET /api/backlog/{task_id}/usage — one entry per completed attempt, oldest first
// (server/models/backlog.py::TaskUsageView). claude_session_id is the direct pointer
// to that attempt's full transcript, for handing a task to a fresh agent to deep-dive.
export interface TaskUsageView {
  task_id: string;
  slot_id: number;
  // ao_v2_node_and_human_slot_recognition_wave2_routing_ui_and_done_bar_2026_09_04
  // (H2) — mirrors server orm.py TaskUsageRow.host: which host settled this attempt
  // (a node-hosted /done is stamped with the node's own host_id; central-hosted ones
  // resolve TaskRow.dispatched_to_host, falling back to the logical host id). null on
  // every pre-migration row — slot_id alone collides across hosts by design.
  host?: string | null;
  account_id: string | null;
  provider: string | null;
  model: string | null;
  claude_session_id: string | null;
  turn_count: number;
  input_tokens: number;
  cache_creation_input_tokens: number;
  cache_read_input_tokens: number;
  output_tokens: number;
  spend_usd: number | null;
  // ao_v2_fleet_visibility_and_reconciliation_2026_09_03 Phase 5 BACKEND P2 (~189) —
  // mirrors server orm.py TaskUsageRow.unmeasured_reason: the human-readable reason a
  // null spend_usd here is a genuine MEASUREMENT failure (node-spool tombstone, or a
  // central /done whose transcript couldn't be resolved), not the far more common,
  // unrelated cause (a model/provider with no registered price). null on every
  // ordinary row, including a genuine "nothing to measure" case — those are honest
  // zeros, not failures, and still write no TaskUsageRow at all.
  unmeasured_reason?: string | null;
  // DeepSeek native-proxy reasoning-token breakdown (deepseek_native_usage_
  // reasoning_tokens_visibility_2026_08_12), joined by claude_session_id against
  // DeepSeekNativeUsageRow. NOT additive spend — a subset WITHIN output_tokens, per
  // DeepSeek's own accounting convention (no separate reasoning rate exists). null =
  // no matching native-usage row (non-DeepSeek attempt, or one that predates the
  // native proxy) — never a 0, which would misreport "measured zero".
  reasoning_tokens: number | null;
  assigned_at: string | null;
  completed_at: string;
  // task_usage_cost_tracking_gaps_2026_08_27 [BACKEND] P2 — TASK-level derived
  // stats identical across attempts (see server/models/backlog.py::TaskUsageView).
  boot_attempt_count?: number;
  time_per_task_seconds?: number | null;
  time_per_turn_seconds?: number | null;
  first_turn_at?: string | null;
  last_turn_at?: string | null;
  // provider_concurrency_backoff_alerting_parity_2026_08_27 [BACKEND] P2: derived
  // tokens/s — TASK-level total output ÷ total wall-time across attempts,
  // directly comparable to Z.ai "Peak avg Decode" (Max&Pro ~85-120 t/s,
  // Lite ~65-95 t/s, 2026-08-21..27 reference — NOT a cap).
  tokens_per_second?: number | null;
}

// v0.7 Phase 2: per-VM aggregation returned by /api/vm/summary
export interface VmAlert {
  severity: "info" | "warn" | "crit";
  kind: string;
  detail: string;
}

export interface VmSummary {
  vm_id: string;
  fqdn: string;
  role: "epic" | "planning" | "unknown";
  label: string | null;
  master_plans: string[];
  slots_total: number;
  slots_working: number;
  slots_idle: number;
  slots_stale: number;
  slots_paused: number;
  slots_blocked: number;
  backlog_total: number;
  backlog_queued: number;
  backlog_done: number;
  backlog_dispatched: number;
  primary_account_id: string | null;
  primary_account_pct: number | null;
  last_activity_at: string | null;
  alerts: VmAlert[];
  watchdog: WatchdogHealth | null;
}

export interface WatchdogKill {
  slot_id: number;
  last_kill_at: string;
}

export interface WatchdogHealth {
  enabled: boolean;
  interval_seconds: number;
  kills_today: number;
  daily_cap: number;
  dormant: boolean;
  kills_date: string;
  recent_kills: WatchdogKill[];
  flapping: boolean;
  slots_killed_last_hour: number;
}

/** Resource-watchdog daemon status (GET /api/resource-watchdog/status).
 *  The cross-process host guardian that kills runaway agent processes. */
export interface ResourceWatchdogStatus {
  service_active: boolean;
  status_file_fresh: boolean;
  pressure_level: "normal" | "high" | "unknown";
  cgroup_mem_gb: number;
  cgroup_max_gb: number;
  rss_limit_gb: number;
  dry_run: boolean;
  poll_interval_sec: number;
  allowlist: string;
  kill_count: number;
  last_kill_iso: string | null;
  uptime_seconds: number;
  orchestrator_url: string;
  marker_dir: string;
  qg_tokens_held: number;
  qg_tokens_max: number;
}

export interface UsageReport {
  weekly_msgs_used?: number | null;
  weekly_window_start?: string | null;
  five_hour_msgs_used?: number | null;
  five_hour_window_start?: string | null;
  rate_limited_until?: string | null;
  by_slot?: number | null;
  source?: "usage_command" | "operator" | "transcript" | "worker";
}

/** GET-adjacent BlockedRow view. Field context worth knowing (not reproduced
 * in the generated schema): `authority` = "main_agent" (the orchestrator agent
 * may answer) vs "operator" (only a human should). `claude_session_id`
 * (blocked_questions_ux_redesign_context_loss_and_scale_2026_07_24) is the
 * ASKING worker's session id, captured at creation time — survives respawns,
 * so the transcript-jump affordance renders the ORIGINAL session even after
 * the slot moves on. `similar_ids` lists OTHER open rows whose normalized
 * question text matches this one's. `context` (opaque JSON) carries
 * structured detector context for plan_health-seeded rows only. */
export type BlockedView = Omit<components["schemas"]["BlockedView"], "similar_ids"> & {
  // group_similar_blocked computes this for every row server-side (default
  // `[]`, never omitted) — the generated schema optionalizes it since the
  // Pydantic field carries a default; narrowed back to required so existing
  // consumers (the blocked-question card in layout.tsx) keep compiling
  // without a defensive `?? []` they don't actually need.
  similar_ids: string[];
};

/** operator_gated_blocked_answer_is_a_no_op_2026_07_30 D3: an operator's
 * structured ruling on a `BLK-op-*` (synthetic, slot_id=0) blocked row — the
 * server materializes a real dispatchable task from it on the next regen tick.
 * "reclassify" hands the todo to `role` as-is; "instruct" dispatches whatever
 * worker picks it up with the operator's free-text `instruction` (which may
 * itself carry compound directions, e.g. "assign to infra then do X and Y" —
 * the dispatched worker reads it verbatim). Absent entirely for an ordinary
 * (non-`BLK-op-*`) blocked answer — the server 400s if sent on one of those. */
export type BlockedRuling = { action: "reclassify"; role: string } | { action: "instruct"; instruction: string };

/** GET /api/escalations/active — CI-failure + scheduled-dispatch escalations a
 * worker currently owns (dispatched <2h ago) or that wait for capacity
 * (queued). See server/escalation.py::list_active_escalations. */
export interface EscalationView {
  escalation_id: string;
  // resolved/unresolved/abandoned are written by the escalation watchdog
  // (server/escalation.py verify_dispatched_escalations) once it polls the
  // wall's real terminal signal — only returned when the caller passes
  // include_resolved_within_hours (api.escalations()); the default (no query
  // param) still returns only queued/dispatched, unchanged from before.
  status: "queued" | "dispatched" | "resolved" | "unresolved" | "abandoned";
  repo: string;
  pr_number: number;
  wall_type: string;
  slot_id: number | null;
  created_at: string | null;
  dispatched_at: string | null;
  /** When the watchdog reached a terminal verdict. null while queued/dispatched. */
  resolved_at: string | null;
  /** Short verdict string, e.g. "qg_v2_green" / "pr_merged" / "still_red_past_deadline". */
  resolution: string | null;
  attempts: number;
  /** MAX_REESCALATIONS-capped counter — distinct from `attempts`, which also counts
   * benign no-capacity dispatch retries and is NOT what the cap gates. */
  reescalations: number;
  /** Reason the head-of-line no-capacity stop last recorded for this row
   * (server/escalation.py `_stamp_no_capacity_reason` / `_no_free_slot_reason`).
   * null on a row never yet evaluated under that stop. */
  last_error: string | null;
  /** When `last_error` was stamped. Deliberately separate from `dispatched_at` —
   * a row can be LOOKED AT this tick without ever being passed to escalate(),
   * so this must not be read as an actual dispatch attempt. */
  last_evaluated_at: string | null;
}

/** GET /api/scheduled-jobs/recent — one dispatch-attempt record for a daily-
 * scheduled planning-cleanup job (plan_reconciler /
 * ag_closeout_auditor / na_eligibility_auditor). See
 * server/state_store/scheduled_jobs.py for why this exists — these systemd
 * timers had zero dashboard/Slack visibility before, only local journalctl. */
export interface ScheduledJobRunView {
  run_id: string;
  job_name: string;
  /** null for non-sharded jobs (plan_reconciler). */
  tranche: string | null;
  started_at: string | null;
  finished_at: string;
  /** dispatched (success) | queued (deferred for capacity, the AutoSpawn drain
   * will dispatch it) | no_capacity (a caller that opted OUT of queueing —
   * ad-hoc/operator only) | paused (the mode is under an operator-set
   * scheduled-dispatch pause — will NEVER resolve on its own, unlike
   * no_capacity/queued; needs POST /api/scheduled-dispatch/{mode}/resume) |
   * quarantined (slot-state safety gate, auto-heal failed) | timeout
   * (curl --max-time hit) | error (anything else unexpected).
   *
   * "queued" (ao_scheduled_job_queue_on_no_capacity_2026_08_06) replaced
   * no_capacity for every SCHEDULED caller: no_capacity recorded a DROPPED
   * dispatch as though it were a routine outcome (368 of 500 attempts over
   * 2026-08-02..06 were lost that way), whereas a queued row is real work that
   * gets retried. A scheduled timer should never report no_capacity again.
   *
   * "paused" (2026-08-20) split out of no_capacity — see
   * server/models/scheduled_jobs.py's ScheduledJobStatus docstring for the
   * full incident (6 modes paused since 2026-08-11 reading as "no capacity
   * x42" on this exact panel days later, real capacity sitting idle). */
  status: "dispatched" | "queued" | "no_capacity" | "paused" | "quarantined" | "timeout" | "error";
  detail: string | null;
  /** The AgentRow.agent_id this run actually spawned — set only when
   * status === "dispatched". Lets the UI deep-link into the existing agent
   * log viewer instead of building a second one. */
  dispatch_agent_id: string | null;
  /** How many times this outcome has been reported for this (job_name,
   * tranche) — 1 on a fresh row, incremented each time a repeat report
   * collapses onto it instead of inserting a duplicate. */
  attempts: number;
  /** Real terminal state of the linked AgentRow (None if no dispatch_agent_id,
   * or the row was purged past its retention window). "dispatched" alone only
   * proves the SPAWN succeeded — never that the audit actually finished, since
   * a one_shot/scheduled worker that goes quiet mid-run gets reaped WITHOUT a
   * clean /done (data_pipeline_failure_one_shot_done_no_agentrow_2026_07_29).
   * "active" = still running; "archived"/"finished" + exit_reason distinguishes
   * a real completion ("lifecycle-complete") from a silent death
   * ("reaped-stale"). */
  agent_status: "active" | "stale" | "archived" | "finished" | null;
  agent_exit_reason: string | null;
  /** WHAT the run reported — AgentRow.done_evidence, the `evidence` string the
   * worker posts to /done with one_shot_complete (2026-08-06). For most
   * scheduled jobs this IS the result: plan_reconciler,
   * ag_closeout_auditor, na_eligibility_auditor and context_scout_auditor all
   * report findings as chat text with no structured endpoint, so before this
   * field the panel could show THAT a dispatch happened but never WHAT it
   * found. null when the run died before /done, and for every run predating
   * the column (the evidence was discarded at the time — not backfillable). */
  agent_done_evidence: string | null;
  /** AgentRow.registered_at/finished_at (2026-08-06) — the worker's REAL
   * spawn/end times, distinct from started_at/finished_at above (which only
   * bracket the dispatch script's HTTP report round-trip, not the actual
   * task runtime). Use these to show "how long the audit actually ran". */
  agent_registered_at: string | null;
  agent_finished_at: string | null;
  /** True only on a genuine clean finish (agent_exit_reason ===
   * "lifecycle-complete"). The single source of truth for "is this row
   * actually done" — never infer done-ness from status/agent_status alone. */
  is_actually_done: boolean | null;
}

/** GET /api/scheduled-dispatch/status — every valid scheduled-dispatch mode
 * name (plan_health.VALID_MODES: reconcile/ag_closeout/
 * na_eligibility/context_scout/cefi_reconciliation/defi_reconciliation/
 * tradfi_reconciliation/prediction_reconciliation/sports_reconciliation/
 * escalation_reconcile/ci_reconcile/data_pipeline_alerts_reconcile/
 * ao_watchdog) plus which ones are currently operator-paused
 * (ao_tmux_session_loss_mid_task_root_cause_2026_08_10, 2026-08-11 — mirrors
 * the existing per-slot pause but keyed by scheduled task TYPE rather than a
 * numbered worker slot). `paused` is always a subset of `modes`. */
export interface ScheduledDispatchStatusView {
  modes: string[];
  paused: string[];
  pause_details: Record<string, { reason: string; paused_at: string }>;
}

/** GET /api/fleet/dispatch-pause-status — the fleet-wide "pause everything"
 * toggle (operator ask 2026-08-30, ao_fleet_pause_dispatch_ui_button_2026_08_30.md).
 * Distinct from ScheduledDispatchPanel's per-mode pause above: this one blocks
 * pick_next_task from claiming NEW work on ANY slot and kills every eligible
 * slot's live session in one action. `reason`/`armed_at` are null when
 * `active` is false. */
export interface DispatchPauseStatusView {
  active: boolean;
  reason: string | null;
  armed_at: string | null;
}

/** GET /api/fleet-freeze-status — the scheduled fleet-wide commit-freeze gate
 * (sit_promote_lease_scheduled_freeze_window_2026_08_29) so full-workspace-sit can
 * validate an unmoving tree. Read-only from the dashboard's side: armed/cleared by
 * the hourly sit-freeze-orchestrator.yml workflow, never by an operator click.
 * `reason`/`armed_at`/`expires_at` are null when `active` is false; `expires_at` is
 * also null while active until the write side starts passing it through (still-open
 * follow-up — see set_fleet_freeze_status's own docstring). */
export interface FleetFreezeStatusView {
  active: boolean;
  reason: string | null;
  armed_at: string | null;
  expires_at: string | null;
}

/** How many queued tasks list this prerequisite in their prereqs: `gates_queued`. */
export type PrerequisiteView = components["schemas"]["PrerequisiteView"];

export interface ActivityEntry {
  /** Row id — the cursor for "Load older" pagination (Plan B). null on legacy callers. */
  id: number | null;
  ts: string;
  event_type: string;
  slot_id: number | null;
  task_id: string | null;
  /** The row's EFFECTIVE host (stored column, else a host its payload names, else central) — slot ids collide
   * across hosts, so `#11` alone is ambiguous. Optional only so older fixtures still type-check. */
  host?: string;
  /** True when `host` is a server default (no stored host, none in the payload: a row from before 2026-09-27), so
   * it must not be shown as a fact. */
  host_inferred?: boolean;
  details: Record<string, unknown>;
}

/** One bucket of the `/api/activity/rollup` denoise count (the "×N in last 1h" badges).
 * `slot_id` present only when the rollup was requested with `by_slot=true`. */
export interface ActivityRollupEntry {
  event_type: string;
  count: number;
  slot_id?: number | null;
}

export interface ActivityRollupResponse {
  within_minutes: number;
  rollup: ActivityRollupEntry[];
}

export interface BacklogSummary {
  queued: number;
  dispatched: number;
  done: number;
  cancelled: number;
  /** Durable auto-park's fleet-wide count (ao_dispatch_cooldown_and_park_2026_07_20
   * todo 3 / surface_parked_tasks_2026_07_25) — a task that has been declined
   * BLOCKED/PARKED/GATED past the skip threshold and is now parked behind a
   * synthetic `auto_unpark__<task_id>` prerequisite, invisible to dispatch until
   * cleared. Optional only for back-compat with an older backend that predates
   * this field — treat a missing value as 0, never as "unknown". */
  auto_parked?: number;
  /** Queued+undispatched tasks claimable by AT LEAST ONE worker slot right now —
   * the SAME `dispatch.claimable_queued_task_ids` SSOT AutoSpawn budgets spawns
   * against (ao_dashboard_critical_health_visibility_2026_08_07). Deliberately
   * NOT the same number as `queued`: a queue can sit non-empty while every row is
   * gated behind an unmet prerequisite/collision, which `queued` alone hides.
   * Optional/undefined means "not computed this poll" (a transient backend read
   * failure) — treat as "unknown", never coerce to 0 (a real 0 is itself the
   * critical signal: real work is queued but nothing can currently claim it). */
  claimable?: number;
}

/** GET /api/state — full fleet snapshot. `backlog_summary` keeps its own
 * hand-typed `BacklogSummary` shape below (the generated schema widens this
 * one field to a bare `Record<string, number>` — the backend serializes it as
 * a plain dict rather than referencing a nested Pydantic model, so
 * openapi-typescript can't recover the richer shape). Every other field is the
 * generated shape verbatim — several (watchdog_dormant/tmux_server_down/
 * recent_orphan_reap_count) are required-with-default server-side so they read
 * as required here too rather than optional; still safe against an older
 * backend, since a validation failure there is loud, not a silent omission.
 * `last_rollback`/`deploy_stale`/`last_dashboard_deploy`/`idle_fleet_blockers`
 * stay nullable-optional (present only once the corresponding condition has
 * ever fired at least once on this deploy). `slots`/`blocked_queue` are ALSO
 * overridden, not just backlog_summary: left alone, they'd resolve to the
 * generated (auto-derived, looser-optionality) SlotView/BlockedView shapes
 * nested inside the raw StateResponse schema rather than this file's own
 * hand-maintained `SlotView`/`BlockedView` exports above — silently breaking
 * every consumer typed against the latter (confirmed live: fleetSlots/
 * criticalHealth call sites and the blocked-question card's `similar_ids`
 * read both failed to compile before this override was added). */
export type StateResponse = Omit<
  components["schemas"]["StateResponse"],
  "backlog_summary" | "slots" | "blocked_queue"
> & {
  backlog_summary: BacklogSummary;
  slots: SlotView[];
  blocked_queue: BlockedView[];
};

/** Fleet-header aggregate for the "N tasks queued, M idle slots" puzzle
 * (ao_fleet_slot_state_reason_tooltips_2026_08_27 Track F) — DISTINCT from each
 * SlotView's own idle_reason: that answers "why is THIS slot idle", this
 * answers "why isn't the current idle fleet draining the backlog", counted
 * once per queued task (not once per idle slot). `top_blockers` maps
 * task_id -> count of queued tasks blocked behind it, top 5, count DESC. */
export type IdleFleetBlockersView = components["schemas"]["IdleFleetBlockersView"];

/** Per-host node health verdict (`state.nodes`) — mirrors the backend's
 * `NodeHealthView` (server/models/state_views.py), rendered by HostGroupHeader. */
export type NodeHealthView = components["schemas"]["NodeHealthView"];

/** The control-plane PM clone's staleness/divergence + the plan-derived
 * dispatch guard's verdict (`state.pm_clone`). The dashboard renders its
 * `blocked_reason` beside "0 of N queued tasks dispatchable" so the count
 * never appears without its cause. */
export type PmCloneView = components["schemas"]["PmCloneView"];

export type LastRollbackView = components["schemas"]["LastRollbackView"];

export type DeployStaleView = components["schemas"]["DeployStaleView"];

/** The versioned dashboard-deploy "operation row" — mirrors the backend's
 * `LastDashboardDeployView` (server/models/state_views.py). Written by
 * `deploy-dashboard.yml`'s report-back call, read here via `state.
 * last_dashboard_deploy` and rendered in the topbar next to `state.version`. */
export type LastDashboardDeployView = components["schemas"]["LastDashboardDeployView"];

export type SlotAffinity = "none" | "low" | "medium" | "high";

// GET /api/backlog/counts -- tab-badge counts without the ~5k-row BacklogTaskView[]
// body (ao_backlog_route_p95_latency_2026_08_26). Mirrors server/models/backlog.py's
// BacklogCounts field-for-field.
// GET /api/backlog/counts -- tab-badge counts without the ~5k-row BacklogTaskView[]
// body (ao_backlog_route_p95_latency_2026_08_26). Mirrors server/models/backlog.py's
// BacklogCounts field-for-field.
export type BacklogCounts = components["schemas"]["BacklogCounts"];

// Cursor-paginated /api/backlog page (ao_control_plane_read_models_and_request_
// path_2026_09_04 [BACKEND] P0). Only returned when the caller passes `cursor`
// and/or `limit` — the default (no params) response stays a bare
// BacklogTaskView[], which `api.backlog()` continues to expose unchanged.
export type BacklogPageView = components["schemas"]["BacklogPageView"];

/** Task definition + live status for /api/backlog reads. `orphan: true` means
 * the row exists in state.db but has no backlog.yaml entry (the dispatcher,
 * which walks backlog.yaml, can never hand it to a worker) — listed rather
 * than hidden, since dropping these is what made the header KPI and this
 * modal disagree (2026-07-17). `effort`/`blocked_reason`/`milestone` are null
 * only for an orphan row (nothing left to read them from). `blocked_reason` is
 * the verbose "why can't this dispatch right now", reusing the real dispatch
 * eligibility table `pick_next_task` enforces, not a reimplementation. */
export type BacklogTaskView = Omit<components["schemas"]["BacklogTaskView"], "affinity"> & {
  // Slot affinity routing (2026-05-19 post-cutover feature) — the generated
  // schema widens this to a bare `string`; narrowed back to the real closed
  // set so SlotAffinity-typed consumers keep compile-time coverage.
  affinity: SlotAffinity;
};

/** GET /api/backlog/graph — docs/BACKLOG_RELATIONS_UX_BRIEF.md §9's data contract.
 * One (slot, task) refusal, joined against LIVE (backlog.yaml-present) tasks only. */
export interface BacklogGraphSkipView {
  slot: number;
  reason: string | null;
}

/** One STRUCTURED blocker edge (brief §6): `kind` names which of the two
 * brief-§3 edge types this is — `"condition"` positionally pairs with an entry
 * in `needs_conditions`, `"task"` with an entry in `after_tasks`. `satisfied`
 * is live ground truth (a condition's current value, or — for a task — done OR
 * completed-and-pruned, the same rule dispatch itself uses). */
export interface BacklogGraphBlockerView {
  kind: "condition" | "task";
  ref: string;
  satisfied: boolean;
}

/** One `GET /api/backlog/graph` task node. A cross-cutting DEPENDENCY GRAPH
 * node, not a plan-tree row (brief §3) — `plan_ref` is one attribute among
 * several, never the organizing container. */
export interface BacklogGraphTaskView {
  id: string;
  title: string;
  plan_ref: string;
  status: TaskStatus;
  tier: number;
  priority: number;
  dispatched_to: number | null;
  assigned_role: string | null;
  collision_group: string | null;
  repos: string[];
  needs_conditions: string[];
  after_tasks: string[];
  explain: string;
  blockers: BacklogGraphBlockerView[];
  skips: BacklogGraphSkipView[];
  orphan: boolean;
}

/** One `GET /api/backlog/graph` condition node. `gates` is the fan-out this
 * graph model exists to surface (brief §5 Q2) — every LIVE task whose
 * `needs_conditions` names this condition, which MAY span multiple plans. */
export interface BacklogGraphConditionView {
  name: string;
  value: boolean;
  set_by: string | null;
  set_at: string | null;
  gates: string[];
}

/** The whole backlog-relations model in one call (brief §9). */
export interface BacklogGraphResponse {
  slots_total: number;
  plans: string[];
  tasks: BacklogGraphTaskView[];
  conditions: BacklogGraphConditionView[];
}

/** GET /api/backlog/parked row (surface_parked_tasks_2026_07_25) — a currently
 * durably auto-parked task, joined against its backlog.yaml detail. */
export interface ParkedTaskView {
  task_id: string;
  title: string;
  brief: string;
  plan_ref: string;
  condition: string;
  reason_code: string;
  skip_count: number;
  armed_at: string | null;
  window_started_at: string | null;
  /** [OPERATOR]-tagged plan todo (BacklogTask.operator_gated) — the HARD gate for
   * whether the dashboard's "Mark done" action is offered at all. */
  operator_gated: boolean;
  /** Soft keyword-scan signal (delete/GCS/gcloud/credential/prod-bucket/etc in the
   * brief, OR operator_gated) — drives the warning badge, independent of the hard
   * operator_gated gate: a GATED park over expired credentials may carry no
   * [OPERATOR] tag yet still need a human to go do something. */
  likely_needs_human_action: boolean;
  orphan: boolean;
}

/** A currently-unresolved `backlog_sibling_reset_guard_refused` collision
 * (ao_backlog_collision_alert_and_remediation_ui_2026_07_26 todo 4) — derived
 * client-side from `/api/activity` rows by `unresolvedBacklogCollisions()`
 * (layout.tsx), never invented: every field here is read straight off the
 * `backlog_sibling_reset_guard_refused` ActivityEntry's `task_id`/`ts`/`details`. */
export interface BacklogCollisionView {
  task_id: string;
  incoming_brief: string;
  existing_done_sha: string | null;
  /** ts of the (latest) `backlog_sibling_reset_guard_refused` activity row for this task_id. */
  first_detected_at: string;
}

export interface ReassignRequest {
  // All optional. Server defaults (when fields omitted):
  //   kill_worker: false       — non-destructive; tmux stays alive
  //   target_slot: <slot_id>   — release task bound back to the same slot
  //   affinity: "high"         — only that slot can claim it
  kill_worker?: boolean;
  target_slot?: number | null;
  affinity?: SlotAffinity | null;
  target_slot_timeout_seconds?: number | null;
}

export interface BackendConfig {
  id: string;
  label: string;
  url: string;
  account_id?: string;
  default?: boolean;
  status?: "ok" | "stale" | "unknown";
  /** Unix-ms timestamp of the last successful /healthz response. */
  last_pinged_at?: number | null;
}

export interface BackendsResponse {
  backends: BackendConfig[];
}

// Auth
export interface LoginRequest {
  username: string;
  password: string;
  backend_id?: string;
}

export interface AuthedUser {
  name: string;
  role: "operator" | "viewer";
  machine: string | null;
}

export interface LoginResponse {
  ok: boolean;
  token: string;
  expires_at: string;
  user: AuthedUser;
}

// Session — held only in React state for the tab's lifetime (never persisted to
// localStorage — ao_dashboard_jwt_localstorage_ws_query_string_unsandboxed_iframe_
// 2026_09_04.md todo 2). A reload re-shows the Login screen; the dashboard's actual
// cross-reload credential is the HttpOnly session cookie, which this type never sees.
export interface Session {
  token: string;
  user: AuthedUser;
  backend_id: string;
  started_at: string;
}

// Agent chat — main / review / custom (NOT workers)

export type AgentRole = "main" | "review" | "custom" | "plan_reconciler" | "human";
// "finished" (Plan B retention): a one_shot/scheduled agent that ran to completion;
// the row is retained (not hard-deleted) so the dashboard can show PAST runs.
export type AgentStatus = "active" | "stale" | "archived" | "finished";
// Two-axis classification (orchestrator_agent_type_oversight_coverage_2026_06_17):
// agent_kind = what the agent DOES (dashboard identity); lifecycle = how long it
// lives (persistent chat agents vs one_shot task workers vs scheduled crons).
export type AgentKind =
  | "orchestrator"
  | "worker"
  | "review"
  | "cicd"
  | "conflict_resolver"
  | "quality_gate_resolution"
  | "plan_health"
  | "plan_reconciler"
  | "data_pipeline_failure"
  | "ag_closeout_auditor"
  | "na_eligibility_auditor"
  | "context_scout_auditor"
  | "monitor"
  | "human"
  | "planning-human"
  | "custom";
export type AgentLifecycle = "persistent" | "one_shot" | "scheduled";
export type MessageDirection = "to_agent" | "from_agent";

export interface AgentView {
  agent_id: string;
  role: AgentRole;
  label: string;
  machine: string | null;
  model: string | null;
  rc_url: string | null;
  rc_session_id: string | null;
  status: AgentStatus;
  online: boolean;
  last_msg: string | null;
  context_used_pct: number;
  /** Live token count behind `context_used_pct`. Null when the reading came from the
   * pane fallback rather than the transcript probe. */
  context_tokens?: number | null;
  /** Window `context_used_pct` was divided by. Surfaced so a wrong window — the
   * actual cause of every context incident so far — is catchable by eye. */
  context_window_tokens?: number | null;
  registered_at: string;
  last_ping: string | null;
  /** Undelivered to_agent messages queued for this agent's role. */
  pending_count: number;
  /** Subset of `pending_count` redelivered up to `agent_message_max_redeliveries`
   * (default 30, ≈30 min at the 60s poll cadence) without the agent ever /reply-acking —
   * i.e. the agent is stuck or dead and the operator's question is going unanswered.
   * The server has computed this since 2026-07-08 (`routes/agents.py` →
   * `count_needs_operator_to_agent`) but nothing rendered it and no alert consumed it, so
   * a genuinely-stuck agent was invisible short of curling the API by hand
   * (ao_dispatch_hardening Phase 2b, 2026-07-16). */
  needs_operator_count: number;
  /** tmux session name when spawned via the dashboard's "Spawn here" button. */
  tmux_session: string | null;
  /** What the agent does — drives the dashboard icon/label. null on rows
   * registered before the 2026-06-17 migration. */
  agent_kind: AgentKind | null;
  /** persistent | one_shot | scheduled — tells the UI a one_shot/scheduled agent
   * legitimately comes and goes (not a stale incident). null pre-migration. */
  lifecycle: AgentLifecycle | null;
  /** Claude account (accounts.json id) this agent runs on. null for pre-migration
   * rows + in-process scheduled agents with no dedicated account. */
  account_id: string | null;
  /** Which provider account_id resolves to ("anthropic" | "deepseek"), per
   * accounts.json — mirrors SlotView.provider. null when account_id itself is null. */
  provider: AccountProvider | null;
  /** Per-agent token usage (deepseek_usage.py generalized, 2026-08-05 follow-up:
   * "tokens per task and by orchestrator" ruling), looked up from the matching
   * slot's session totals. null = no matching slot, or no poller tick yet. */
  session_input_tokens: number | null;
  session_output_tokens: number | null;
  /** Cache-token split (ao_fleet_cache_tokens_and_task_count_2026_08_05) — same
   * lookup/null-contract as the pair above. */
  session_cache_creation_input_tokens: number | null;
  session_cache_read_input_tokens: number | null;
  /** Live $ spend (ao_fleet_live_spend_badge_2026_08_05) — same lookup/null-contract
   * as the pair above. */
  session_spend_usd: number | null;
  /** DeepSeek native-proxy reasoning-token breakdown (deepseek_native_usage_
   * reasoning_tokens_visibility_2026_08_12) — same lookup/null-contract as the pair
   * above, but joined by claude_session_id against DeepSeekNativeUsageRow rather
   * than read off the transcript-parse path the fields above use (DeepSeek's
   * Anthropic-compat endpoint silently drops it). NOT additive spend. */
  session_reasoning_tokens: number | null;
  /** Retention (Plan B): when a terminal (status="finished") agent finished. null for live agents. */
  finished_at: string | null;
  /** Retention (Plan B): why a terminal agent exited (e.g. "reaped: tmux gone"). null for live agents. */
  exit_reason: string | null;
  /** What the agent is currently doing (task_id / "plan health" / "repo#PR — wall_type"). */
  current_task: string | null;
  /** Kind-specific source context: repo name for cicd, alert-id for data_pipeline_failure, etc. */
  source: string | null;
  /** Deterministic Claude session-id (`claude --session-id`) for --resume failover. */
  claude_session_id: string | null;
}

export interface ChatMessage {
  id: number;
  direction: MessageDirection;
  from_role: string;
  content: string;
  created_at: string;
  // Present when the sender was an authenticated agent (not the dashboard
  // operator). Display alongside from_role as "<role> (<agent_id>)".
  from_agent_id?: string | null;
  // Only meaningful for direction="to_agent" — null means still awaiting the
  // agent's reply. The "pending only" history filter keys off this.
  answered_at?: string | null;
}

export interface AgentHistory {
  agent_id: string;
  messages: ChatMessage[];
}

// Agent role registry (GET /api/roles) — the static, schematized role catalog
// (main / review / cicd / data_engineering / plan-health / …). Read-only in the
// dashboard: the Registry tab renders this. `has_frontmatter=false` marks a role
// whose prompt file exists but carries no parsed schema block (unschematized).
export type RoleModel = "opus" | "sonnet" | "haiku";
export type RoleLifecycle = "persistent" | "one_shot" | "scheduled";

export interface RoleView {
  role: string;
  model: RoleModel;
  thinking: string | null;
  lifecycle: RoleLifecycle;
  escalation_to: string | null;
  reports_to: string | null;
  temperament_base: string | null;
  does: string[];
  does_not: string[];
  triggers: string[];
  skills: string[];
  has_frontmatter: boolean;
}

// ─── transcript viewer (ao_fleet_transcript_collapsible_viewer_2026_08_25) ─────
//
// One parsed block from GET /api/agents/{id}/log and GET /api/slots/{id}/log's
// `structured` field (server/transcript_log.py::parse_transcript_events) — the
// SAME tool_use/tool_result/thinking/text data the flattened `lines` string
// renders, kept typed instead of flattened so TranscriptView can render it as a
// collapsible transcript instead of one plain-text blob.

export interface TranscriptTextEvent {
  /** Stable per-event id (the source transcript line's own uuid, `:<block index>`
   * suffixed when a line carries several blocks) — use as the React `key` so a
   * `<details>` row's open/closed state survives the 5s poll re-render even as
   * the `max_lines` tail window slides forward. */
  id: string;
  kind: "user_text" | "assistant_text" | "thinking" | "system";
  ts: string;
  sidechain: boolean;
  text: string;
}

export interface TranscriptToolResult {
  is_error: boolean;
  /** Present when the tool result is plain text (most tools). */
  text?: string | null;
  /** Present instead of `text` for a Bash-shaped result — stdout/stderr kept
   * separate so the viewer can render them as distinct blocks. */
  stdout?: string | null;
  stderr?: string | null;
}

export interface TranscriptToolCallEvent {
  id: string;
  kind: "tool_call";
  ts: string;
  sidechain: boolean;
  name: string;
  input: unknown;
  tool_id: string | null;
  /** null when no matching tool_result has landed in the parsed window yet. */
  result: TranscriptToolResult | null;
}

export type TranscriptEvent = TranscriptTextEvent | TranscriptToolCallEvent;

/**
 * One model's death picture: the transcript `died_mid_task` flag next to the activity
 * log's own work-losing `tmux_session_lost` count, over the same window
 * (`GET /api/backlog/usage/death-rates`, ao_death_reasons_gate_starvation_and_cost_
 * columns_findings_2026_10_02 [BACKEND] P2).
 *
 * The two rates have DIFFERENT denominators on purpose and both are published so a
 * reader can renormalise: `flagged_per_100` divides by `row_count` (the flag is a
 * per-row property, and that is the basis the panel has always shown), while
 * `activity_per_100` divides by `task_count` (a death is a per-task event). They are
 * never summed into one number — the gap between them is the finding (measured
 * 2026-10-02: GLM 0.6% flagged vs 14.3 per 100 tasks from the activity log).
 *
 * `provider` is null when no usage row in the window carried one (the model appears
 * only through activity-log deaths) — never guessed.
 */
export interface ModelDeathRateView {
  model: string;
  provider: string | null;
  task_count: number;
  row_count: number;
  flagged_death_rows: number;
  activity_death_count: number;
  flagged_per_100: number;
  activity_per_100: number;
}

/** Envelope for the per-model death rates — carries the resolved window and the count of
 * work-losing slot deaths whose event stamped no model (measured ~190 over 7 days, nearly
 * all node kills), surfaced so a per-model rate is never read as the whole picture. */
export interface ModelDeathRatesView {
  window: string;
  window_seconds: number;
  unattributed_activity_deaths: number;
  models: ModelDeathRateView[];
}
